export type Language = "ar" | "en";

export const translations = {
  // ===== TOP BANNER =====
  topBanner: {
    ar: {
      text: "🎬 شوف لحظات قمة بائعي رنين 2026 —",
      link: "شاهد الفعالية كاملة",
      href: "/learn/seller-event",
    },
    en: {
      text: "🎬 Watch the raneen Seller Summit 2026 highlights —",
      link: "Watch the full event",
      href: "/learn/seller-event",
    },
  },

  // ===== NAVBAR =====
  navbar: {
    ar: {
      start: "ابدأ",
      grow: "كبّر شغلك",
      services: "الخدمات",
      resources: "الموارد",
      pricing: "الأسعار",
      language: "English",
      login: "دخول",
      register: "سجّل دلوقتي",
    },
    en: {
      start: "Start",
      grow: "Grow",
      services: "Services",
      resources: "Resources",
      pricing: "Pricing",
      language: "العربية",
      login: "Log in",
      register: "Sign up",
    },
  },

  // ===== MEGA MENU =====
  megaMenu: {
    ar: {
      start: {
        left: {
          title: "اتعلم إزاي تبيع",
          items: [
            { label: "إزاي تبيع على رنين", desc: "تعلم الأساسيات وابدأ رحلتك", path: "/sell" },
            { label: "إضافة المنتجات", desc: "اعرف إزاي تضيف وتعمل قوائم منتجات", path: "/sell/listing-products" },
            { label: "تسعير المنتجات", desc: "اعرف إزاي تحط أسعار تنافسية", path: "/sell/pricing-products" },
            { label: "توصيل الطلبات", desc: "اختار طريقة التوصيل المناسبة", path: "/sell/fulfillment" },
            { label: "الإعلانات والترويج", desc: "زوّد ظهورك بالإعلانات والعروض", path: "/grow/advertising" },
          ],
        },
        right: {
          title: "دليل البائع الجديد",
          items: [
            { label: "اكتشف الدليل", desc: "حقق 6 أضعاف مبيعات السنة الأولى", path: "/grow", badge: "جديد" },
            { label: "سجل العلامات التجارية", desc: "احمِ واطلق البراند بتاعك", path: "/grow/brand-registry" },
            { label: "محتوى A+", desc: "زوّد مبيعاتك بقوائم منتجات احترافية", path: "/grow/a-plus-content" },
            { label: "التوصيل عن طريق رنين", desc: "إنت بتبيعه وإحنا بنشحنه ونرجعه", path: "/sell/fbr" },
            { label: "حوافز البائع الجديد", desc: "استفاد من عروض تصل لـ 50,000 جنيه", path: "/grow/new-seller-incentives" },
          ],
        },
      },
      grow: {
        left: {
          title: "كبّر مبيعاتك",
          items: [
            { label: "دليل البائع الجديد", desc: "أدوات واستراتيجيات لتكبير شغلك", path: "/grow" },
            { label: "الإعلانات", desc: "زوّد ظهورك ومبيعاتك بالإعلانات", path: "/grow/advertising" },
            { label: "سجل العلامات التجارية", desc: "اطلق واحمِ البراند بتاعك", path: "/grow/brand-registry" },
            { label: "محتوى A+", desc: "زوّد مبيعاتك بقوائم احترافية", path: "/grow/a-plus-content" },
            
          ],
        },
        right: {
          title: "أدوات إضافية",
          items: [
            { label: "واجهة المتجر", desc: "ابني صفحة متجرك المخصصة", path: "/grow/storefront" },
            { label: "حوافز البائع الجديد", desc: "استفاد من عروض تصل لـ 50,000 جنيه", path: "/grow/new-seller-incentives" },
            { label: "بيع في فروعنا", desc: "اعرض منتجاتك في فروع رنين", path: "/grow#brick-and-mortar" },
          ],
        },
      },
      services: {
        left: {
          title: "خدمات التوصيل",
          items: [
            { label: "التوصيل عن طريق رنين (FBR)", desc: "خزّن منتجاتك عندنا وإحنا بنوصّلها مباشرة", path: "/sell/fbr", badge: "قريبًا" },
            { label: "الشحن والتوصيل", desc: "خيارات شحن مرنة لشغلك", path: "/sell/fulfillment" },
            { label: "توصيل متعدد القنوات", desc: "بيع على أي منصة ورنين بتوصل", path: "/services/multi-channel" },
            { label: "سلسلة التوريد", desc: "حلول لوجستية شاملة", path: "/services/supply-chain" },
          ],
        },
        right: {
          title: "أدوات البراند",
          items: [
            { label: "سجل العلامات التجارية", desc: "احمِ البراند بتاعك", path: "/grow/brand-registry" },
            { label: "محتوى A+", desc: "حسّن صفحات منتجاتك", path: "/grow/a-plus-content" },
            { label: "واجهة المتجر", desc: "صمم متجرك المخصص", path: "/grow/storefront" },
          ],
        },
      },
      resources: {
        left: {
          title: "للمبتدئين",
          items: [
            { label: "مركز التعلم", desc: "ابدأ رحلتك كبائع على رنين", path: "/learn" },
            { label: "جامعة البائع", desc: "فيديوهات تعليمية من الخبراء", path: "/learn#seller-university" },
            { label: "إيه تبيع", desc: "اكتشف فرص المنتجات المربحة", path: "/sell/what-to-sell" },
            { label: "ندوات وفعاليات", desc: "انضم لتدريبات وورش عمل مباشرة", path: "/learn/webinars" },
          ],
        },
        right: {
          title: "المجتمع والدعم",
          items: [
            { label: "قصص نجاح", desc: "اسمع من بائعين ناجحين على رنين", path: "/learn/seller-stories" },
            { label: "الأسئلة الشائعة", desc: "إجابات للأسئلة المتكررة", path: "/learn/faq" },
            { label: "مركز المساعدة", desc: "دعم فني وإجابات سريعة", path: "/learn#help" },
          ],
        },
      },
      pricing: {
        left: {
          title: "الرسوم الأساسية",
          items: [
            { label: "خطط البيع", desc: "اختار الخطة اللي تناسب شغلك", path: "/pricing" },
            { label: "رسوم العمولة", desc: "العمولات حسب فئة المنتج", path: "/pricing#referral-fees" },
            { label: "رسوم التوصيل", desc: "تكلفة الشحن بطرق مختلفة", path: "/pricing#fees" },
          ],
        },
        right: {
          title: "تكاليف إضافية",
          items: [
            { label: "تكاليف إضافية", desc: "رسوم الخدمات الاختيارية", path: "/pricing/optional-costs" },
            { label: "حاسبة الأرباح", desc: "احسب أرباحك المتوقعة", path: "/pricing#calculator" },
          ],
        },
      },
    },
    en: {
      start: {
        left: {
          title: "Learn how to sell",
          items: [
            { label: "How to Sell on raneen", desc: "Learn the basics and start your journey", path: "/sell" },
            { label: "Listing Products", desc: "Find out how to match or create listings", path: "/sell/listing-products" },
            { label: "Pricing Products", desc: "Understand how to set competitive prices", path: "/sell/pricing-products" },
            { label: "Fulfilling Customer Orders", desc: "Decide on a fulfillment method", path: "/sell/fulfillment" },
            { label: "Promoting and Advertising", desc: "Drive discovery with promotions and ads", path: "/grow/advertising" },
          ],
        },
        right: {
          title: "Get the New Seller Guide",
          items: [
            { label: "Explore the Guide", desc: "Generate 6x more first-year sales", path: "/grow", badge: "New" },
            { label: "Brand Registry", desc: "Protect and build your brand", path: "/grow/brand-registry" },
            { label: "A+ Content", desc: "Increase sales with better listings", path: "/grow/a-plus-content" },
            { label: "Fulfillment by raneen", desc: "Outsource shipping, returns, and customer service", path: "/sell/fbr" },
            { label: "New Seller Incentives", desc: "Unlock EGP 50,000 using the guide", path: "/grow/new-seller-incentives" },
          ],
        },
      },
      grow: {
        left: {
          title: "Grow your sales",
          items: [
            { label: "New Seller Guide", desc: "Tools and strategies to scale your business", path: "/grow" },
            { label: "Advertising", desc: "Boost visibility and sales with ads", path: "/grow/advertising" },
            { label: "Brand Registry", desc: "Launch and protect your brand", path: "/grow/brand-registry" },
            { label: "A+ Content", desc: "Increase sales with enhanced listings", path: "/grow/a-plus-content" },
            
          ],
        },
        right: {
          title: "More tools",
          items: [
            { label: "Seller Storefront", desc: "Build your custom store page", path: "/grow/storefront" },
            { label: "New Seller Incentives", desc: "Unlock EGP 50,000 in benefits", path: "/grow/new-seller-incentives" },
            { label: "Sell in Our Stores", desc: "Showcase products in raneen stores", path: "/grow#brick-and-mortar" },
          ],
        },
      },
      services: {
        left: {
          title: "Fulfillment services",
          items: [
            { label: "Fulfillment by raneen (FBR)", desc: "Store with us, we deliver direct", path: "/sell/fbr", badge: "Coming soon" },
            { label: "Shipping & Delivery", desc: "Flexible shipping options for your business", path: "/sell/fulfillment" },
            { label: "Multi-Channel Fulfillment", desc: "Sell anywhere, raneen delivers", path: "/services/multi-channel" },
            { label: "Supply Chain", desc: "End-to-end logistics solutions", path: "/services/supply-chain" },
          ],
        },
        right: {
          title: "Brand tools",
          items: [
            { label: "Brand Registry", desc: "Protect your brand", path: "/grow/brand-registry" },
            { label: "A+ Content", desc: "Enhance your product pages", path: "/grow/a-plus-content" },
            { label: "Seller Storefront", desc: "Design your custom store", path: "/grow/storefront" },
          ],
        },
      },
      resources: {
        left: {
          title: "For beginners",
          items: [
            { label: "Learning Hub", desc: "Start your journey as a raneen seller", path: "/learn" },
            { label: "Seller University", desc: "Expert-led tutorial videos", path: "/learn#seller-university" },
            { label: "What to Sell", desc: "Discover profitable product opportunities", path: "/sell/what-to-sell" },
            { label: "Webinars & Events", desc: "Join live training and workshops", path: "/learn/webinars" },
          ],
        },
        right: {
          title: "Community & support",
          items: [
            { label: "Seller Stories", desc: "Hear from successful raneen sellers", path: "/learn/seller-stories" },
            { label: "FAQs", desc: "Answers to common questions", path: "/learn/faq" },
            { label: "Help Center", desc: "Technical support and quick answers", path: "/learn#help" },
          ],
        },
      },
      pricing: {
        left: {
          title: "Standard fees",
          items: [
            { label: "Selling Plans", desc: "Choose the plan that fits your business", path: "/pricing" },
            { label: "Commission Fees", desc: "Referral fees by product category", path: "/pricing#referral-fees" },
            { label: "Fulfillment Fees", desc: "Shipping costs across methods", path: "/pricing#fees" },
          ],
        },
        right: {
          title: "Additional costs",
          items: [
            { label: "Optional Costs", desc: "Fees for optional services and programs", path: "/pricing/optional-costs" },
            { label: "Revenue Calculator", desc: "Estimate your potential profits", path: "/pricing#calculator" },
          ],
        },
      },
    },
  },

  // ===== HERO =====
  hero: {
    ar: {
      title1: "بيع على رنين:",
      title2: "ابدأ بيع أونلاين النهارده!",
      cta: "سجّل دلوقتي",
      subtitle: "لفترة محدودة، الحسابات الاحترافية متاحة دلوقتي بخصم 50% على رسوم الاشتراك الشهري.",
    },
    en: {
      title1: "Sell on raneen:",
      title2: "start selling online today!",
      cta: "Sign up",
      subtitle: "For a limited time only, Professional accounts are now available with 50% discount on monthly subscription fee.",
    },
  },

  // ===== WHY SELL =====
  whySell: {
    ar: {
      heading: "ليه تبيع على رنين؟",
      features: [
        {
          title: "وصّل لملايين",
          description: "أصحاب براندات وموزعين. شركات جديدة وشركات كبيرة. الكل بيبيع على رنين لسبب واحد: ملايين الناس بتتسوق من عندنا.",
          link: "إزاي بيشتغل",
        },
        {
          title: "بيع في محلاتنا",
          description: "منتجاتك ممكن تتعرض في أكتر من 58 فرع من فروع رنين في كل أنحاء مصر. وصّل لعملاء أكتر أوفلاين وأونلاين.",
          link: "اعرف عن البيع في الفروع",
        },
        {
          title: "توصيل من غير قلق",
          description: "سواء اخترت التوصيل عن طريق رنين أو التوصيل عن طريق التاجر (FBS)، إحنا بنتولى إدارة شحن منتجاتك والمرتجعات وخدمة العملاء.",
          link: "اكتشف الشحن",
        },
        {
          title: "اكسب فلوس",
          description: "تكلفة البيع على رنين بتعتمد على نوع المنتجات اللي بتبيعها وطريقة التوصيل. الخيارات مرنة عشان تناسب شغلك وأهدافك.",
          link: "اعرف الأسعار",
        },
      ],
    },
    en: {
      heading: "Why sell on raneen?",
      features: [
        {
          title: "Reach millions",
          description: "Brand owners and resellers. Fresh new startups and Fortune 500s. They all sell on raneen for a reason: millions of customers shop our stores.",
          link: "How it works",
        },
        {
          title: "Sell in our stores",
          description: "Your products can be featured in 58+ raneen physical store locations across Egypt. Reach more customers both offline and online.",
          link: "See in-store selling",
        },
        {
          title: "Deliver stress-free",
          description: "Whether you choose Fulfillment by raneen (FBR) or Managed by raneen (MBR), let us manage shipping your products, returns and customer service.",
          link: "Explore shipping",
        },
        {
          title: "Make money",
          description: "The cost to sell on raneen depends on which category of products you sell, and how you plan to fulfill orders. The options are flexible.",
          link: "See pricing",
        },
      ],
    },
  },

  // ===== SUCCESS STORIES =====
  successStories: {
    ar: {
      heading: "قصص نجاح",
      stories: [
        {
          name: "صاحب - دكان علاء",
          role: "علاء الدين",
          quote: "الذكاء الاصطناعي في لوحة التحكم الجديدة من رنين غيّر شغلنا بالكامل. بقينا بنفهم عملاءنا أكتر وبنبيع أحسن.",
          stat: "+97%",
          statLabel: "نمو سنوي",
        },
        {
          name: "صاحب - كرافت للأثاث",
          role: "مصطفى عبدالحميد",
          quote: "رنين إدتنا الفرصة نتصرف زي براند كبير. بيوفرولنا كل الدعم وإحنا بنقدم أحسن المنتجات لعملاءنا.",
          stat: "233%",
          statLabel: "نمو المبيعات ٢٠٢٥ مقابل ٢٠٢٦",
        },
        {
          name: "صاحب - الأندلس للتكييفات",
          role: "زيد علي",
          quote: "إحنا مبسوطين إن فلوس مبيعاتنا بتوصلنا بسرعة، ده بيخلينا نقدر ندير المشتريات والكاش فلو بتاعنا كويس.",
          stat: "160%",
          statLabel: "معدل النمو السنوي المركب لسنتين",
        },
      ],
    },
    en: {
      heading: "Success Stories",
      stories: [
        {
          name: "Owner - Dukan Alaa",
          role: "Alaa El Din",
          quote: "The AI built into raneen's new dashboard transformed how we operate. We understand our customers better and sell smarter.",
          stat: "+97%",
          statLabel: "Year-over-year growth",
        },
        {
          name: "Owner - Craft Furniture",
          role: "Mustafa Abdelhamid",
          quote: "raneen gave us the opportunity to act like a big brand. They provide all the support and we deliver our best products.",
          stat: "233%",
          statLabel: "Sales growth 2025 vs 2026",
        },
        {
          name: "Owner - Al Andalos for Air Conditioner",
          role: "Zaid Ali",
          quote: "We are happy that we receive our sales cash very fast so we can manage our buying & cash flow.",
          stat: "160%",
          statLabel: "2-years CAGR",
        },
      ],
    },
  },

  // ===== HOW TO SELL =====
  howToSell: {
    ar: {
      heading: "إزاي تبيع على رنين؟",
      subtitle: "مش عارف تبدأ منين؟ انضم لتدريباتنا التفاعلية ونزّل دليل البائع المبتدئ.",
      steps: [
        { title: "افتح حسابك", desc: "سجّل كبائع على رنين في دقايق" },
        { title: "ضيف منتجاتك", desc: "ارفع منتجاتك وحدد الأسعار" },
        { title: "اشحن طلباتك", desc: "إحنا بنتولى الشحن أو اشحن بنفسك" },
        { title: "اكسب فلوسك", desc: "استلم أرباحك بسهولة وأمان" },
      ],
      guideCta: "دليل البائع المبتدئ",
      webinarCta: "انضم للتدريب المباشر",
    },
    en: {
      heading: "How to sell on raneen?",
      subtitle: "Don't know how to proceed? Join us today for interactive training sessions and download our quick beginners guide.",
      steps: [
        { title: "Create your account", desc: "Register as a seller on raneen in minutes" },
        { title: "Add your products", desc: "Upload your products and set prices" },
        { title: "Ship your orders", desc: "We handle shipping or ship yourself" },
        { title: "Earn profits", desc: "Receive your profits easily and securely" },
      ],
      guideCta: "Beginner's Guide",
      webinarCta: "Join live Webinar",
    },
  },

  // ===== FOOTER =====
  footer: {
    ar: {
      helpTitle: "لسه محتاج مساعدة في التسجيل؟",
      helpText: "استفاد من دليل التسجيل والتدريبات المباشرة أو كلمنا للدعم",
      contactCta: "كلمنا",
      newsletterTitle: "ابقى على تواصل - اشترك عشان تاخد نصايح مفيدة",
      emailPlaceholder: "إيميلك",
      subscribe: "اشترك",
      rights: "كل الحقوق محفوظة لرنين.كوم",
      brandsProgram: "برنامج العلامات التجارية",
      privacyNotice: "سياسة الخصوصية",
      termsOfUse: "شروط الاستخدام",
      startSellingTitle: "ابدأ بيع النهارده",
      startSellingText: "اعرض منتجاتك قدام ملايين الناس اللي بتتسوق من رنين كل يوم.",
      startSellingCta: "سجّل دلوقتي",
      limitedOffer: "لفترة محدودة، الحسابات الاحترافية متاحة دلوقتي بخصم 50% على رسوم الاشتراك الشهري.",
    },
    en: {
      helpTitle: "Still need help registering?",
      helpText: "Leverage our Registration Guide and Webinars for live Q&A or Contact us for support",
      contactCta: "Contact us",
      newsletterTitle: "Stay connected - Sign up for helpful tips",
      emailPlaceholder: "Your email address",
      subscribe: "Subscribe",
      rights: "All rights reserved to raneen.com",
      brandsProgram: "Brands Program",
      privacyNotice: "Privacy Notice",
      termsOfUse: "Conditions of Use",
      startSellingTitle: "Start selling today",
      startSellingText: "Put your products in front of the millions of customers who search raneen every day.",
      startSellingCta: "Register now",
      limitedOffer: "For a limited time only, Professional accounts are now available with 50% discount on monthly subscription fee.",
    },
  },

  // ===== SELL PAGE =====
  sellPage: {
    ar: {
      heroTitle: "بيع أونلاين: اتعلم إزاي تبيع على رنين",
      heroText: "سواء عندك بيزنس شغال أو عندك فكرة منتج جديد أو بتحب البيع، دي أول خطوات عشان تتعلم إزاي تبيع على رنين مصر. ابدأ رحلتك النهارده.",
      webinarCta: "انضملنا في ندوة مباشرة عن إزاي تبيع على رنين ‹",
      sections: {
        beforeStart: "قبل ما تبدأ",
        helpGuides: "أدلة المساعدة",
        helpGuidesText: "وقفت في التسجيل؟ مش عارف تكمل إزاي؟ انضملنا النهارده لجلسات التدريب التفاعلية ونزّل دليل التسجيل السريع عشان يساعدك تطلق شغلك على رنين مصر.",
        downloadGuide: "نزّل دليل التسجيل",
        sellingStrategy: "حدد استراتيجية البيع بتاعتك",
        sellingStrategyText: "في بائعين بيقدموا منتجات بيصنعوها بنفسهم، وفي بائعين بيدوروا على حاجات حلوة عشان يعيدوا بيعها. في طريقتين أساسيتين هيأثروا على استراتيجية البيع بتاعتك.",
        reselling: "إعادة البيع",
        resellingText: "دوّر على منتج موجود أصلاً في متاجر رنين واعرض حالته (جديد أو مستعمل). يعني إنت بتبيع منتج متاح أصلاً.",
        privateLabelTitle: "العلامة الخاصة",
        privateLabelText: "اصنع أو جيب منتجات عشان تبيعها تحت البراند بتاعك. ده محتاج تعمل قوائم جديدة بعناوين وأوصاف وصور مميزة.",
        fulfillmentStrategy: "اختار طريقة التوصيل",
        fulfillmentText: "لكل منتج بتبيعه، هتحتاج توصله للمشتري. عندك كذا خيار:",
        fbrTitle: "التوصيل عن طريق رنين\n(FBR)",
        fbrText: "خزّن منتجاتك في مخازن رنين وإحنا بنتولى التغليف والتوصيل المباشر للعملاء وخدمة العملاء والمرتجعات.",
        fbrComingSoon: "قريبًا",
        liveBadge: "متاح",
        easyShipTitle: "مُدار بواسطة رنين\n(MBR)",
        easyShipText: "إنت بتخزّنه وإحنا بنديره. خلّي منتجاتك في مخزنك وسواق رنين هيوصلها للعملاء.",
        selfShipTitle: "التوصيل عن طريق التاجر\n(FBS)",
        selfShipText: "التاجر بيتولى تخزين وتغليف وشحن منتجاتك للعملاء من مخازنه.",
        createAccount: "افتح حساب بائع",
        createAccountText: "عشان تبدأ بيع على رنين، لازم يكون عندك حساب بائع. اضغط على 'سجّل دلوقتي' عشان تبدأ. قبل ما تبدأ، تأكد إن عندك المعلومات دي:",
        accountReqs: [
          "إيميل شغال أو حساب عميل على رنين",
          "رقم موبايل تقدر توصلك عليه",
          
          "للأفراد - بطاقة رقم قومي مصرية (وإحنا هنساعدك تستخرج سجل تجاري فردي)",
          "للشركات - سجل تجاري وبطاقة ضريبية",
          "حساب بنكي عشان تستلم فلوس المبيعات",
        ],
        addingProducts: "ضيف منتجاتك",
        productCategories: "فئات المنتجات",
        productCategoriesText: "في فئات مفتوحة لكل البائعين، وفي فئات محتاجة حساب احترافي، وفي فئات محتاجة موافقة مسبقة.",
        productDetails: "تفاصيل المنتج",
        productDetailsText: "عشان تعمل قائمة منتج، هتحتاج توفر: كود المنتج (UPC, EAN, ISBN)، السعر، حالة المنتج، الكمية المتاحة، وخيارات الشحن.",
        listingOptimize: "حسّن القائمة بتاعتك",
        listingOptimizeText: "خلّي قوائمك أحسن بعناوين واضحة، صور جودة عالية، وأوصاف مفصلة تساعد الناس تاخد قرار الشرا.",
        aiOptimize: "حسّن منتجاتك بالذكاء الاصطناعي",
        aiOptimizeText: "خلّي الذكاء الاصطناعي يشتغل! أداتنا الذكية بتحلل قوائم منتجاتك وبتقترح تحسينات فورية على العناوين والأوصاف والكلمات المفتاحية عشان تزوّد ظهورك ومبيعاتك.",
        aiFeatures: [
          "عمل عناوين وأوصاف احترافية أوتوماتيك",
          "اقتراح كلمات مفتاحية عالية الأداء",
          "تحسين الصور وتوصيات الجودة",
          "تحليل المنافسين واقتراحات تسعير",
        ],
        aiCta: "جرّب التحسين بالذكاء الاصطناعي",
        importProducts: "استورد منتجاتك من أي منصة",
        importProductsText: "انقل متجرك كله لرنين في دقايق! استورد كل منتجاتك من أي منصة تجارة إلكترونية تانية بضغطة واحدة.",
        importPlatforms: [
          { name: "Shopify", desc: "استورد الكتالوج كله من شوبيفاي مباشرة" },
          { name: "WooCommerce", desc: "انقل منتجات ووكومرس بسهولة" },
          { name: "جمالي / سلة", desc: "استورد من المنصات العربية المحلية" },
          { name: "ملف CSV", desc: "ارفع ملف Excel أو CSV عشان تضيف منتجاتك مرة واحدة" },
        ],
        importCta: "ابدأ الاستيراد دلوقتي",
      },
    },
    en: {
      heroTitle: "Sell Online: Learn How to Sell on raneen",
      heroText: "Whether you already have an established e-commerce business, a great idea for a new product, or a passion for selling, here are the first steps to learning how to sell on raneen Egypt. Start your journey today.",
      webinarCta: "Join us for a live webinar on how to sell on raneen ›",
      sections: {
        beforeStart: "Before you start",
        helpGuides: "Help Guides",
        helpGuidesText: "Stuck during registration? Don't know how to proceed? Join us today for interactive training sessions and download our quick registration guide to help you launch and kickstart your business to sell on raneen Egypt.",
        downloadGuide: "Download the registration guide",
        sellingStrategy: "Consider your selling strategy",
        sellingStrategyText: "Some sellers offer products they make themselves, and some source amazing materials to resell. There are two basic strategies that will shape your overall selling approach.",
        reselling: "Reselling",
        resellingText: "Find a product that already exists in raneen stores and offer your condition (new or used). This means you're selling a product that is already available.",
        privateLabelTitle: "Private Label",
        privateLabelText: "Manufacture or source products to sell under your own brand. This requires building new listings with unique titles, descriptions, and images.",
        fulfillmentStrategy: "Choose your fulfillment strategy",
        fulfillmentText: "For every product you sell, you'll need to get it to the buyer. You have several options:",
        fbrTitle: "Fulfillment by raneen\n(FBR)",
        fbrText: "Store your products in raneen's fulfillment centers and we handle packing, direct delivery to customers, customer service and returns.",
        fbrComingSoon: "Coming soon",
        liveBadge: "Live",
        easyShipTitle: "Managed by raneen\n(MBR)",
        easyShipText: "You store it, we manage it. Keep your products in your warehouse and a raneen driver will deliver them to customers.",
        selfShipTitle: "Fulfillment by Seller\n(FBS)",
        selfShipText: "Seller handles storing, packing, and shipping your products to customers from their warehouses.",
        createAccount: "Create a seller account",
        createAccountText: "To start selling on raneen, you must have a seller account. Click 'Register now' to get started. Before you start, make sure you have the following information ready:",
        accountReqs: [
          "Valid email address or raneen customer account",
          "Mobile number where you are reachable",
          
          "For Individuals – Egyptian National ID (we'll help you obtain a sole-proprietor Commercial Registration)",
          "For Businesses – Commercial Registration and Tax Card",
          "A bank account where raneen can send you proceeds from your sales",
        ],
        addingProducts: "Adding your products",
        productCategories: "Product categories",
        productCategoriesText: "Some categories are open to all sellers, some require a Professional account, and some require prior approval.",
        productDetails: "Product details",
        productDetailsText: "To create a product listing, you'll need to provide: Product ID (UPC, EAN, ISBN), Price, Product condition, Available quantity, and Shipping options.",
        listingOptimize: "Listing optimization",
        listingOptimizeText: "Make your listings more attractive with clear titles, high-quality images, and detailed descriptions that help customers make purchase decisions.",
        aiOptimize: "Optimize all products with AI",
        aiOptimizeText: "Let AI do the heavy lifting! Our smart tool analyzes your product listings and suggests instant improvements to titles, descriptions, and keywords to boost your visibility and sales.",
        aiFeatures: [
          "Auto-generate professional titles & descriptions",
          "Suggest high-performing keywords",
          "Image quality analysis & recommendations",
          "Competitor analysis & pricing suggestions",
        ],
        aiCta: "Try AI Optimization",
        importProducts: "Import products from any platform",
        importProductsText: "Move your entire store to raneen in minutes! Import all your products from any other e-commerce platform with just one click.",
        importPlatforms: [
          { name: "Shopify", desc: "Import your full catalog from Shopify directly" },
          { name: "WooCommerce", desc: "Transfer your WooCommerce products seamlessly" },
          { name: "Noon / Jumia", desc: "Import from regional marketplaces effortlessly" },
          { name: "CSV File", desc: "Upload an Excel or CSV file to bulk-add your products" },
        ],
        importCta: "Start importing now",
      },
    },
  },

  // ===== FULFILLMENT PAGE =====
  fulfillmentPage: {
    ar: {
      heroTitle: "خيارات التوصيل في رنين - توصيل طلباتك للعملاء",
      heroText: "إنت بتبيعه وإحنا بنشحنه. ممكن تختار التوصيل عن طريق رنين (FBR) أو مُدار بواسطة رنين (MBR) أو التوصيل عن طريق التاجر (FBS). بائعين رنين كتير بيستخدموا مزيج من FBR و MBR.",
      freeStorageTitle: "تخزين ببلاش*، إزالة، وإرجاع",
      freeStorageText: "جرّب التوصيل عن طريق رنين دلوقتي واستمتع بتخزين ببلاش في مراكز التوصيل بتاعتنا وإزالة ببلاش ومعالجة إرجاع ببلاش مع برنامج التشكيلة الجديدة (الشروط سارية).",
      optionsTitle: "اختار الطريقة المناسبة ليك",
      fbrTitle: "التوصيل عن طريق رنين (FBR)",
      fbrText: "خزّن منتجاتك في مراكز توصيل رنين وإحنا بنتولى التغليف والتوصيل المباشر للعملاء وخدمة العملاء والمرتجعات. عشان تساعدك توسع شغلك وتوصل لعملاء أكتر.",
      fbrBenefits: ["تخزين في مراكز رنين", "توصيل مباشر للعملاء", "خدمة عملاء ومرتجعات", "شارة FBR على منتجاتك"],
      fbrComingSoon: "قريبًا",
      mbrTitle: "مُدار بواسطة رنين (MBR)",
      mbrText: "خلّي منتجاتك في مخزنك وسواق رنين هيجي يوصلها للعملاء. إنت بتخزّنه وإحنا بنديره.",
      mbrBenefits: ["خلّي مخزونك عندك", "سواق رنين بيوصل", "رسوم شحن تنافسية", "تتبع الشحنات"],
      fbsTitle: "التوصيل عن طريق التاجر (FBS)",
      fbsText: "التاجر بيتولى تخزين وتغليف وشحن منتجاته للعملاء من مخازنه الخاصة.",
      fbsBenefits: ["تحكم كامل في الشحن", "مرونة في التسعير", "من غير رسوم تخزين", "إدارة مباشرة للمخزون"],
      comparisonTitle: "مقارنة بين خيارات التوصيل",
      learnMore: "قارن خيارات الشحن",
    },
    en: {
      heroTitle: "raneen Fulfillment - Getting shoppers their stuff",
      heroText: "You sell it, we ship it. You can either opt for Fulfillment by raneen (FBR), Managed by raneen (MBR) or Fulfillment by Seller (FBS). Many raneen selling partners use a mix of FBR and MBR.",
      freeStorageTitle: "Free storage*, removals, and returns",
      freeStorageText: "Try Fulfillment by raneen now and enjoy on eligible items free storage in our fulfillment centers, free removals, and free return processing with the FBR New Selection program (conditions apply).",
      optionsTitle: "Choose the right option for you",
      fbrTitle: "Fulfillment by raneen (FBR)",
      fbrText: "Store your products in raneen's fulfillment centers and we handle packing, direct delivery to customers, customer service and returns. Helping you scale your business and reach more customers.",
      fbrBenefits: ["Storage in raneen centers", "Direct delivery to customers", "Customer service & returns", "FBR badge on your products"],
      fbrComingSoon: "Coming soon",
      mbrTitle: "Managed by raneen (MBR)",
      mbrText: "Keep your products in your warehouse and a raneen driver will pick them up and deliver to customers. You store it, we manage it.",
      mbrBenefits: ["Keep your inventory", "raneen drivers deliver", "Competitive shipping fees", "Shipment tracking"],
      fbsTitle: "Fulfillment by Seller (FBS)",
      fbsText: "Seller handles storing, packing, and shipping products to customers from their own warehouses.",
      fbsBenefits: ["Full control over shipping", "Flexible pricing", "No storage fees", "Direct inventory management"],
      comparisonTitle: "Compare fulfillment options",
      learnMore: "Compare fulfillment options",
    },
  },

  // ===== FBR PAGE =====
  fbrPage: {
    ar: {
      heroTitle: "وفّر وقتك وكبّر شغلك مع التوصيل عن طريق رنين FBR",
      heroText: "بتبيع على رنين أو بدأت جديد؟",
      ctaExisting: "ابدأ دلوقتي",
      ctaNew: "سجّل دلوقتي",
      ctaNewSub: "لفترة محدودة، الحسابات الاحترافية متاحة دلوقتي بخصم 50% على رسوم الاشتراك الشهري",
      howItWorks: "إزاي بيشتغل FBR؟",
      steps: [
        { title: "ابعت منتجاتك", desc: "جهّز منتجاتك وابعتها لمراكز توصيل رنين" },
        { title: "إحنا بنخزّنها", desc: "بنحفظ منتجاتك بأمان في مراكزنا" },
        { title: "العميل بيطلب", desc: "لما العميل يطلب، إحنا بنتولى كل حاجة" },
        { title: "بنوصّلها", desc: "بنغلّف ونشحن ونوصّل للعميل" },
      ],
      benefitsTitle: "مميزات FBR",
      benefits: [
        { title: "شارة FBR", desc: "منتجاتك بتظهر بشارة FBR اللي بتزوّد ثقة العملاء" },
        { title: "توصيل أسرع", desc: "العملاء بيستلموا طلباتهم أسرع من مراكز التوصيل بتاعتنا" },
        { title: "خدمة عملاء", desc: "إحنا بنتولى خدمة العملاء والمرتجعات بالنيابة عنك" },
        { title: "وفّر وقتك", desc: "ركّز على تطوير شغلك وسيب الشحن والتوصيل لينا" },
      ],
      freeProgram: "برنامج التشكيلة الجديدة",
      freeProgramText: "جرّب FBR دلوقتي واستمتع بتخزين ببلاش في مراكز التوصيل وإزالة ببلاش ومعالجة إرجاع ببلاش على المنتجات المؤهلة.",
    },
    en: {
      heroTitle: "Save time and help grow your business with raneen FBR",
      heroText: "Already selling on raneen or just getting started?",
      ctaExisting: "Get started",
      ctaNew: "Register now",
      ctaNewSub: "For a limited time only, Professional accounts are now available with 50% discount on monthly subscription fee",
      howItWorks: "How does FBR work?",
      steps: [
        { title: "Send your products", desc: "Prepare your products and send them to raneen fulfillment centers" },
        { title: "We store them", desc: "We safely store your products in our centers" },
        { title: "Customer orders", desc: "When a customer orders, we handle everything" },
        { title: "We deliver", desc: "We pack, ship, and deliver to the customer" },
      ],
      benefitsTitle: "FBR Benefits",
      benefits: [
        { title: "FBR Badge", desc: "Your products display the FBR badge that increases customer trust" },
        { title: "Faster delivery", desc: "Customers receive their orders faster from our fulfillment centers" },
        { title: "Customer service", desc: "We handle customer service and returns on your behalf" },
        { title: "Save time", desc: "Focus on growing your business and leave shipping and delivery to us" },
      ],
      freeProgram: "New Selection Program",
      freeProgramText: "Try FBR now and enjoy free storage in our fulfillment centers, free removals, and free return processing on eligible items.",
    },
  },

  // ===== ADVERTISING PAGE =====
  advertisingPage: {
    ar: {
      heroLabel: "الإعلانات",
      heroTitle: "زوّد ظهورك ومبيعاتك على رنين بالإعلانات",
      heroText: "عارف إن الإعلانات المموّلة ممكن تساعدك تزوّد ظهورك وتوصل لمتسوقين أكتر وتزوّد مبيعاتك؟",
      ctaExisting: "ابدأ الإعلان",
      ctaNew: "سجّل دلوقتي",
      goalsTitle: "حقق أهداف شغلك",
      goals: [
        { title: "زوّد الظهور", desc: "ساعد المتسوقين يلاقوا منتجاتك عن طريق الإعلانات في نتائج البحث وصفحات المنتجات." },
        { title: "زوّد الطلب", desc: "شجّع المتسوقين يفكروا في منتجاتك مع إعلانات جذابة." },
        { title: "زوّد المبيعات", desc: "ساعد في تحويل المتسوقين لعملاء بإعلانات في اللحظة المناسبة." },
      ],
      adTypesTitle: "أنواع الإعلانات",
      adTypes: [
        { title: "المنتجات المموّلة", desc: "اعرض منتجاتك في نتائج البحث وعلى صفحات تفاصيل المنتج. ادفع بس لما حد يضغط على إعلانك." },
        { title: "إعلانات البراند", desc: "اعرض البراند بتاعك وتشكيلة منتجاتك في أعلى نتائج البحث." },
        { title: "إعلانات العرض", desc: "وصّل لعملاء داخل وبرا رنين بإعلانات مرئية." },
      ],
      caseStudyLabel: "قصة نجاح",
      caseStudy: {
        brand: "كرافت للأثاث",
        category: "أثاث · مصر",
        quote: "رنين إدتنا الفرصة نتصرف زي براند كبير. بيوفرولنا كل الدعم وإحنا بنقدم أحسن المنتجات لعملاءنا.",
        author: "مصطفى عبدالحميد، المؤسس",
        stats: [
          { value: "+٣٢٠٪", label: "زيادة في الظهور" },
          { value: "+٢٣٣٪", label: "نمو المبيعات ٢٠٢٥ مقابل ٢٠٢٦" },
          { value: "٥٦x", label: "عائد الإنفاق الإعلاني" },
        ],
      },
    },
    en: {
      heroLabel: "ADVERTISING",
      heroTitle: "Increase visibility and sales on raneen with advertising",
      heroText: "Did you know that sponsored ads can help you boost your visibility, reach more shoppers and increase your sales?",
      ctaExisting: "Start advertising",
      ctaNew: "Sign up",
      goalsTitle: "Achieve your business goals",
      goals: [
        { title: "Build awareness", desc: "Help shoppers discover your products through ads in search results and product pages." },
        { title: "Drive consideration", desc: "Encourage shoppers to consider your products with engaging ad creatives." },
        { title: "Increase sales", desc: "Help convert shoppers into customers with ads at the right moment." },
      ],
      adTypesTitle: "Ad Types",
      adTypes: [
        { title: "Sponsored Products", desc: "Feature your products in shopping results and on product detail pages. Pay only when your ad is clicked." },
        { title: "Sponsored Brands", desc: "Showcase your brand and product portfolio at the top of search results." },
        { title: "Display Ads", desc: "Reach customers on and off raneen with visually rich display ads." },
      ],
      caseStudyLabel: "Success story",
      caseStudy: {
        brand: "Craft Furniture",
        category: "Furniture · Egypt",
        quote: "raneen gave us the chance to act like a big brand. They provide all the support we need while we deliver the best products to our customers.",
        author: "Moustafa Abdelhamid, Founder",
        stats: [
          { value: "+320%", label: "Visibility lift" },
          { value: "+233%", label: "Sales growth 2025 vs 2026" },
          { value: "56x", label: "Return on ad spend" },
        ],
      },
    },
  },

  // ===== BRAND REGISTRY PAGE =====
  brandRegistryPage: {
    ar: {
      heroTitle: "اطلق البراند بتاعك مع رنين",
      heroText: "سجّل البراند بتاعك في سجل العلامات التجارية على رنين عشان تبدأ تفتح مجموعة أدوات لبناء البراند وحمايته.",
      ctaEnroll: "سجّل البراند بتاعك",
      ctaLogin: "سجّل دخول لسجل العلامات التجارية",
      whyTitle: "ليه سجل العلامات التجارية على رنين؟",
      whyText: "سجل العلامات التجارية على رنين برنامج مجاني بيساعدك تحمي وتكبّر البراند بتاعك، حتى لو مش بتبيع على رنين.",
      benefits: [
        { title: "أمّن البراند بتاعك", desc: "اكتشف وبلّغ عن انتهاكات الملكية الفكرية المشتبه فيها بأدواتنا القوية." },
        { title: "حوّل عملاء أكتر", desc: "حسّن صفحات منتجاتك بمحتوى محسّن وصور وفيديوهات وأويول مقارنة." },
        { title: "اعرف عملاءك", desc: "احصل على رؤى قيمة عن سلوك البحث والشراء عشان تحسّن استراتيجيتك." },
      ],
      toolsTitle: "أدوات بناء البراند",
      tools: [
        { title: "محتوى A+", desc: "اعمل صفحات منتجات غنية بصور وفيديوهات ومقارنات عشان تزوّد التحويل." },
        { title: "متجر البراند", desc: "اعمل وجهة تسوق مخصصة للبراند بتاعك على رنين." },
        { title: "تحليلات البراند", desc: "تابع أداء البراند بتاعك بتقارير وتحليلات متقدمة." },
        { title: "حماية البراند", desc: "أدوات أوتوماتيكية لحماية البراند بتاعك من الانتهاكات." },
      ],
      eligibilityTitle: "إزاي تتأهل؟",
      eligibilityReqs: [
        "حساب بائع احترافي نشط",
        "علامة تجارية مسجلة نشطة ظاهرة على منتجاتك",
        "القدرة على التحقق إنك صاحب الحقوق أو الوكيل المعتمد",
      ],
    },
    en: {
      heroTitle: "Launch your brand with raneen",
      heroText: "Enroll your brand in raneen Brand Registry to start unlocking a suite of brand-building tools and protection benefits.",
      ctaEnroll: "Enroll your brand",
      ctaLogin: "Log in to Brand Registry",
      whyTitle: "Why raneen Brand Registry?",
      whyText: "raneen Brand Registry is a free program that helps you protect and grow your brand, even if you don't sell in the raneen store.",
      benefits: [
        { title: "Secure your brand", desc: "Detect and report suspected IP infringement with our powerful tools. Accurate submissions drive our feedback loops to block violations automatically." },
        { title: "Convert more customers", desc: "Enhance your product pages with rich content, images, videos, and comparison tables." },
        { title: "Know your customers", desc: "Get valuable insights about search and purchase behavior to improve your strategy." },
      ],
      toolsTitle: "Brand building tools",
      tools: [
        { title: "A+ Content", desc: "Create rich product pages with images, videos, and comparisons to increase conversion." },
        { title: "Brand Store", desc: "Create a custom shopping destination for your brand on raneen." },
        { title: "Brand Analytics", desc: "Track your brand performance with advanced reports and analytics." },
        { title: "Brand Protection", desc: "Automated tools to protect your brand from infringement." },
      ],
      eligibilityTitle: "How to qualify?",
      eligibilityReqs: [
        "An active Professional seller account",
        "An active registered trademark that appears on your products",
        "The ability to verify yourself as the rights owner or authorized agent",
      ],
    },
  },

  // ===== WEBINARS PAGE =====
  webinarsPage: {
    ar: {
      heroTitle: "ندوات وفعاليات رنين",
      heroText: "انضم لندواتنا وورش العمل عشان تتعلم إزاي تبدأ متجر رنين في مصر وتحسّنه وتوصله للنجاح.",
      upcomingTitle: "الندوات القادمة",
      upcomingEvents: [
        { title: "إزاي تبدأ البيع على رنين", date: "كل أسبوع - الأحد 2:00 م", desc: "ندوة شاملة للمبتدئين عن كل خطوات التسجيل وبدء البيع." },
        { title: "أسرار نجاح البائعين", date: "كل أسبوعين - الثلاثاء 3:00 م", desc: "اتعلم من بائعين ناجحين واستراتيجياتهم لتكبير المبيعات." },
        { title: "إعلانات رنين المتقدمة", date: "كل شهر - الخميس 1:00 م", desc: "اتعلم إزاي تعمل حملات إعلانية فعّالة وتحقّق أعلى عائد." },
        { title: "التوصيل عن طريق رنين (FBR)", date: "كل أسبوعين - الأربعاء 11:00 ص", desc: "كل حاجة محتاج تعرفها عن FBR وإزاي تبدأ." },
      ],
      registerCta: "سجّل في الندوة",
      pastTitle: "ندوات سابقة",
      pastText: "اتفرج على تسجيلات الندوات السابقة وتعلم في وقتك.",
      topicsTitle: "المواضيع اللي بنغطيها",
      topics: [
        "التسجيل وإعداد الحساب",
        "إنشاء قوائم المنتجات",
        "استراتيجيات التسعير",
        "التوصيل والشحن",
        "الإعلانات والتسويق",
        "بناء البراند",
      ],
    },
    en: {
      heroTitle: "raneen Webinars and Events",
      heroText: "Join our webinars and workshops to learn how to start a raneen store in Egypt, optimize it, and lead it to success.",
      upcomingTitle: "Upcoming Webinars",
      upcomingEvents: [
        { title: "How to Start Selling on raneen", date: "Weekly - Sunday 2:00 PM", desc: "Comprehensive webinar for beginners covering all registration and selling steps." },
        { title: "Secrets of Successful Sellers", date: "Bi-weekly - Tuesday 3:00 PM", desc: "Learn from successful sellers and their strategies to grow sales." },
        { title: "Advanced raneen Advertising", date: "Monthly - Thursday 1:00 PM", desc: "Learn how to create effective ad campaigns and maximize ROI." },
        { title: "Fulfillment by raneen (FBR)", date: "Bi-weekly - Wednesday 11:00 AM", desc: "Everything you need to know about FBR and how to get started." },
      ],
      registerCta: "Register for webinar",
      pastTitle: "Past Webinars",
      pastText: "Watch recordings of past webinars and learn at your own pace.",
      topicsTitle: "Topics we cover",
      topics: [
        "Registration & account setup",
        "Creating product listings",
        "Pricing strategies",
        "Fulfillment & shipping",
        "Advertising & marketing",
        "Brand building",
      ],
    },
  },

  // ===== GROW PAGE =====
  growPage: {
    ar: {
      heroTitle: "بيع أكتر مع نظام رنين الشمولي",
      heroText: "بعد ما اتعلمت أساسيات إزاي تبيع على رنين، اعرف الأدوات المتاحة عشان تساعدك تكبّر شغلك.",
      findFormula: "لاقي المعادلة بتاعتك",
      findFormulaText: "تكبير مبيعاتك كبائع بيشمل إضافة تشكيلة متنوعة، جذب زيارات لمنتجاتك، توسيع نطاق وصولك، وتقديم تجربة عملاء تحفة.",
      fbrTitle: "احصل على شارة FBR",
      fbrText: "إنت بتبيعه وإحنا بنشحنه. رنين عندها واحدة من أكتر شبكات التوصيل تطوراً. مع التوصيل عن طريق رنين (FBR)، ببساطة ابعتلنا منتجاتك وإحنا بنتولى التخزين والتوصيل وخدمة العملاء.",
      fbrLearnMore: "اعرف أكتر عن خيارات التوصيل",
      freeStorage: "تخزين ببلاش*، إزالة، وإرجاع",
      freeStorageText: "جرّب التوصيل عن طريق رنين دلوقتي واستمتع بتخزين ببلاش في مراكز التوصيل بتاعتنا وإزالة ببلاش ومعالجة إرجاع ببلاش مع برنامج التشكيلة الجديدة.",
      marketing: "التسويق",
      advertiseTitle: "اعمل إعلانات وروّج لمنتجاتك",
      advertiseText: "ساعد في زيادة المبيعات وإطلاق منتجات جديدة وتعزيز ظهور المنتجات بأي من الاستراتيجيات دي.",
      sponsoredAds: "إعلانات مموّلة",
      sponsoredAdsText: "ساعد في عرض منتجاتك في نتائج البحث وعلى صفحات تفاصيل المنتج، وادفع بس لما حد يضغط على إعلانك.",
      promotions: "عروض ترويجية",
      promotionsText: "قدّم شحن ببلاش أو خصومات بالنسبة أو عروض اشتري واحد وخد واحد على منتجاتك.",
      deals: "صفقات",
      dealsText: "شغّل تخفيضات سريعة عشان تشجع الناس تستفيد من أسعارك المخفضة.",
      coupons: "كوبونات",
      couponsText: "قدّم كوبونات في نتائج البحث وصفحات تفاصيل المنتج وسلات التسوق.",
      brandServices: "خدمات البراند",
      buildBrand: "ابني البراند بتاعك",
      buildBrandText: "لو عندك علامة تجارية مسجلة، سجل العلامات التجارية هو خدمة ببلاش بتساعد في حماية ملكيتك الفكرية وبتفتحلك أدوات زي المحتوى المحسّن ولوحة تحكم البراند.",
      brandReqs: [
        "حساب بائع احترافي",
        "علامة تجارية مسجلة نشطة ظاهرة على منتجاتك",
        "القدرة على التحقق إنك صاحب الحقوق أو الوكيل المعتمد",
      ],
      automatedPricing: "تسعير أوتوماتيك",
      automatedPricingTitle: "خلّي الأمور بسيطة",
      automatedPricingText: "قواعد التسعير بتساعد عروضك تفضل في نطاق محدد. الأسعار بتتغير أوتوماتيك استجابة لأحداث زي تغيير العرض المميز أو أقل سعر.",
      accountHealth: "صحة الحساب",
      accountHealthTitle: "اتبع أحسن الممارسات",
      accountHealthText: "تابع مؤشرات أدائك، واتابع إشعارات لوحة التحكم، واهتم بعملاءك.",
      brickAndMortar: "بيع في فروعنا",
      brickAndMortarLabel: "فروع رنين الفعلية",
      brickAndMortarTitle: "وصّل منتجاتك لعملاء الفروع",
      brickAndMortarText: "البائعين المؤهلين يقدروا يعرضوا منتجاتهم في فروع رنين الفعلية المنتشرة في مصر. اجمع بين قوة البيع أونلاين والتواجد على أرض الواقع عشان تضاعف مبيعاتك.",
      brickAndMortarBenefits: [
        "تواجد في 58 فرع رنين في مصر",
        "اعرض منتجاتك قدام آلاف الناس كل يوم",
        "إدارة موحدة للمخزون أونلاين وأوفلاين",
        "دعم تسويقي جوه الفرع مع لافتات وعروض مميزة",
      ],
      brickAndMortarQualify: "إزاي تتأهل؟",
      brickAndMortarQualifyText: "البائعين اللي بيستوفوا معايير الجودة والأداء يقدروا يتقدموا لبرنامج البيع في الفروع. بنقيّم المنتجات على أساس:",
      brickAndMortarCriteria: [
        "تقييمات العملاء (4 نجوم فأكتر)",
        "سجل أداء ممتاز على المنصة",
        "جودة التغليف والبراند",
        "القدرة على تلبية حجم الطلبات",
      ],
      brickAndMortarCta: "تقدّم للبيع في الفروع",
      brickAndMortarExampleLabel: "مثال من أرض الواقع",
      brickAndMortarExampleTitle: "شاشات العرض التفاعلية في فروع رنين",
      brickAndMortarExampleCaption: "شاشات تفاعلية بتعرض منتجات البائعين في الفروع — العميل يتصفح، يشوف العروض، ويدفع من نفس المكان.",
      stats: {
        countries: "فرع",
        cities: "مدينة",
        marketplaces: "سوق",
      },
    },
    en: {
      heroTitle: "Sell more with raneen's Omnichannel",
      heroText: "Once you know the basics of how to sell on raneen, learn about the tools available to help you grow your business.",
      findFormula: "Find your formula",
      findFormulaText: "Growing as a seller involves adding selection, driving traffic to your products, expanding your reach, and delivering a great customer experience.",
      fbrTitle: "Get the FBR badge",
      fbrText: "You sell it, we ship it. raneen has one of the most advanced fulfillment networks. With Fulfillment by raneen (FBR), simply send us your products, and we take care of storage, delivery, customer service and returns handling.",
      fbrLearnMore: "Learn more about fulfillment options",
      freeStorage: "Free storage*, removals, and returns",
      freeStorageText: "Try Fulfillment by raneen now and enjoy free storage in our fulfillment centers, free removals, and free return processing with the FBR New Selection program.",
      marketing: "Marketing",
      advertiseTitle: "Advertise and promote your listings",
      advertiseText: "Help increase sales, launch new products, and boost product visibility by using any of these strategies.",
      sponsoredAds: "Sponsored ads",
      sponsoredAdsText: "Help feature your products in shopping results and on product detail pages, and pay only when your ad is clicked.",
      promotions: "Promotions",
      promotionsText: "Offer free shipping, percentage discounts, or buy-one-get-one promos on your products.",
      deals: "Deals",
      dealsText: "Run flash sales to encourage people to take advantage of your lowered prices while they last.",
      coupons: "Coupons",
      couponsText: "Offer coupons in shopping results, product detail pages, and customer Shopping Carts.",
      brandServices: "Brand Services",
      buildBrand: "Build your brand",
      buildBrandText: "If you have a registered trademark, Brand Registry is a free service that not only helps protect your intellectual property, but also unlocks tools like A+ Content and the Brand Dashboard.",
      brandReqs: [
        "A Professional selling account",
        "An active registered trademark that appears on your products",
        "The ability to verify yourself as the rights owner or authorized agent",
      ],
      automatedPricing: "Automated Pricing",
      automatedPricingTitle: "Keep things simple",
      automatedPricingText: "Pricing rules help your offers stay within a set range. Prices change automatically in response to events like featured offer or lowest price changes.",
      accountHealth: "Account Health",
      accountHealthTitle: "Follow best practices",
      accountHealthText: "Keep an eye on your performance metrics, stay up to date with notifications, and obsess over customers.",
      brickAndMortar: "Sell in Our Stores",
      brickAndMortarLabel: "raneen PHYSICAL STORES",
      brickAndMortarTitle: "Get your products on store shelves",
      brickAndMortarText: "Qualified sellers can showcase their products in raneen's brick-and-mortar stores across Egypt. Combine the power of online selling with a real-world retail presence to maximize your sales potential.",
      brickAndMortarBenefits: [
        "Presence in 58 raneen store locations across Egypt",
        "Expose your products to thousands of daily shoppers",
        "Unified inventory management across online & offline",
        "In-store marketing support with signage and featured displays",
      ],
      brickAndMortarQualify: "How to qualify?",
      brickAndMortarQualifyText: "Sellers who meet our quality and performance standards can apply for the in-store selling program. We evaluate products based on:",
      brickAndMortarCriteria: [
        "Customer ratings (4 stars and above)",
        "Excellent performance track record on the platform",
        "Packaging and branding quality",
        "Ability to meet order volume demands",
      ],
      brickAndMortarCta: "Apply for in-store selling",
      brickAndMortarExampleLabel: "Real-world example",
      brickAndMortarExampleTitle: "Interactive kiosks in raneen stores",
      brickAndMortarExampleCaption: "Self-service kiosks showcase seller products inside our stores — shoppers browse categories, view special offers, and pay right there.",
      stats: {
        countries: "Stores",
        cities: "Cities",
        marketplaces: "Marketplaces",
      },
    },
  },

  // ===== PRICING PAGE =====
  pricingPage: {
    ar: {
      heroTitle: "هيكل رسوم البيع على رنين: كبّر شغلك",
      heroText: "تكلفة البيع على رنين بتعتمد على خطة البيع ونوع المنتج وطريقة التوصيل وخدمات تانية. الخيارات مرنة عشان تلاقي المزيج اللي يناسبك.",
      referralFees: "رسوم العمولة",
      referralFeesText: "رنين بتاخد عمولة على كل منتج يتباع. المبلغ بيعتمد على نوع المنتج. أغلب العمولات بين 3% و15%.",
      seeReferralFees: "شوف رسوم العمولة",
      fulfillmentFees: "رسوم التوصيل",
      fulfillmentFeesText: "تكلفة شحن طلباتك بتعتمد على لو بتستخدم مُدار بواسطة رنين (MBR) ولا التوصيل عن طريق رنين (FBR) ولا التوصيل عن طريق التاجر (FBS).",
      seeFulfillmentFees: "شوف رسوم التوصيل",
      otherCosts: "تكاليف تانية",
      otherCostsText: "بعض البائعين ممكن يتحملوا رسوم إضافية (زي رسوم التخزين طويل الأجل) أو يدفعوا مقابل برامج اختيارية زي الإعلانات.",
      seeOtherCosts: "شوف التكاليف التانية",
      gettingPaid: "استلام الأرباح ودفع الرسوم",
      gettingPaidText: "لما تفتح حساب بائع، هتقدم رقم كريديت كارد وحساب بنكي. فلوس المبيعات هيتم إيداعها في حسابك البنكي (بعد خصم الرسوم).",
      feeStructure: "هيكل الرسوم",
      feeStructureText: "معدلات الرسوم للبيع على رنين بتختلف على حسب الفئة وقناة التوصيل.",
      easyShipFees: "رسوم مُدار بواسطة رنين\n(MBR)",
      selfShipFees: "رسوم التوصيل عن طريق التاجر\n(FBS)",
      fbrFees: "رسوم التوصيل عن طريق رنين\n(FBR)",
      referralFee: "رسوم العمولة",
      shippingFee: "رسوم الشحن",
      fulfillmentFee: "رسوم التوصيل",
      storageFee: "رسوم التخزين الشهرية",
      longTermStorageFee: "رسوم التخزين طويل الأجل",
      shippingCost: "تكلفة الشحن",
      referralFeeDesc: "بتبدأ من 3% أو حد أدنى 5 ج.م، بتختلف حسب الفئة",
      shippingFeeDesc: "بتبدأ من 42 ج.م لكل شحنة، بتختلف حسب الحجم*",
      shippingFeeNote: "*البائعين يقدروا يحصّلوا رسوم شحن من العملاء لحد 26 ج.م لكل شحنة",
      selfShipDesc: "التاجر بيتولى تخزين وتغليف وشحن منتجاتك للعملاء، الرسوم بتختلف حسب الحجم والوزن",
      fbrFulfillmentDesc: "بتبدأ من 15.5 ج.م لكل وحدة، بتختلف حسب الحجم",
      storageDesc: "رسوم التخزين على أساس متوسط الحجم اليومي بالقدم المكعب في الشهر",
      longTermDesc: "المخزون اللي في مراكز التوصيل لأكتر من 365 يوم بيتحمل رسوم تخزين طويل الأجل",
      vatNote: "ملاحظة: كل الرسوم المذكورة معروضة من غير ضريبة القيمة المضافة. هيتم تطبيق ضريبة القيمة المضافة على كل الرسوم المعروضة فوق.",
      plansTitle: "خطط البيع",
      plansText: "اختار الخطة اللي تناسب شغلك. ابدأ ببلاش وكبّر لما تكون جاهز.",
      plans: [
        {
          name: "ستارتر",
          price: "999 ج.م/شهر",
          badge: "",
          desc: "ابدأ متجرك على رنين بكل الأساسيات اللي محتاجها.",
          features: [
            "مبيعات شهرية غير محدودة",
            "الدفع عند الاستلام (COD)",
            "دومين مخصص",
            "شحن مع راية و موفكس و أرإكسبريس",
          ],
          cta: "اختر",
        },
        {
          name: "جروث",
          price: "2,499 ج.م/شهر",
          badge: "الأكثر شيوعاً",
          desc: "كبّر مبيعاتك بطرق دفع وأدوات تسويق أكتر.",
          features: [
            "كل مميزات ستارتر",
            "الدفع بالبطاقة (Visa/MC/Meeza)*",
            "التقسيط (فاليو/سهولة/أمان)*",
            "أولوية الإرسال مع RExpress",
            "أدوات SEO",
          ],
          cta: "اختر",
        },
        {
          name: "احترافي",
          price: "4,999 ج.م/شهر",
          badge: "",
          desc: "كل المميزات لتكبير شغلك على أعلى مستوى.",
          features: [
            "كل مميزات جروث",
            "بيع في فروعنا",
            "أدوات الذكاء الاصطناعي (نسخ + صور)",
            "أدوات عروض الشحن المجاني",
            "دورة تحويل بأولوية",
          ],
          cta: "اختر",
        },
      ],
      categoryFeesTitle: "رسوم العمولة حسب الفئة",
      category: "الفئة الرئيسية",
      subCategory: "الفئة الفرعية",
      referralFeePercentage: "نسبة العمولة",
      referralFeeMinimum: "الحد الأدنى للعمولة",
      catalogSyncTitle: "خطط تحديث الكتالوج",
      catalogSyncSubtitle: "كل الأسعار بالجنيه المصري / في الشهر",
      catalogSyncPlans: [
        { name: "شهري", price: "499", currency: "ج.م", syncs: "مزامنة واحدة / شهر", perSync: "499 لكل مزامنة", cta: "اختر" },
        { name: "نصف شهري", price: "749", currency: "ج.م", syncs: "مزامنتين / شهر", perSync: "375 لكل مزامنة", cta: "اختر" },
        { name: "أسبوعي", price: "999", currency: "ج.م", syncs: "~4 مزامنات / شهر", perSync: "250 لكل مزامنة", cta: "اختر", badge: "الأكثر شيوعاً" },
        { name: "يومي", price: "1,499", currency: "ج.م", syncs: "~30 مزامنة / شهر", perSync: "50 لكل مزامنة", cta: "اختر" },
      ],
      payAsYouGoLabel: "بدون اشتراك",
      payAsYouGoTitle: "ادفع حسب الاستخدام",
      payAsYouGoDesc: "سحب كتالوج لمرة واحدة. لقطة فقط — بدون مزامنة مستمرة.",
      payAsYouGoPrice: "15 ج.م",
      payAsYouGoUnit: "لكل منتج (أي عدد من SKUs)",
      compareTitle: "قارن كل المميزات",
      compareFeatureCol: "الميزة",
      compareRows: [
        { feature: "المبيعات الشهرية", free: "غير محدودة", scale: "غير محدودة", pro: "غير محدودة" },
        { feature: "الدفع عند الاستلام (COD)", free: true, scale: true, pro: true },
        { feature: "الدفع بالبطاقة (Visa/MC/Meeza)*", free: false, scale: true, pro: true },
        { feature: "التقسيط (فاليو/سهولة/أمان)*", free: false, scale: true, pro: true },
        { feature: "دورة تحويل أسرع", free: false, scale: "قياسية", pro: "أولوية" },
        { feature: "دومين مخصص", free: true, scale: true, pro: true },
        { feature: "شركاء الشحن (راية، موفكس، أرإكسبريس)", free: true, scale: true, pro: true },
        { feature: "أولوية الإرسال مع RExpress", free: false, scale: true, pro: true },
        { feature: "أدوات عروض الشحن المجاني", free: false, scale: false, pro: true },
        { feature: "أدوات SEO", free: false, scale: true, pro: true },
        { feature: "أدوات الذكاء الاصطناعي (نسخ + صور)", free: false, scale: false, pro: true },
      ],
      compareFootnote: "* رسوم معالجة الدفع تنطبق على كل عملية. كل الأسعار من غير ضريبة القيمة المضافة (14%).",
    },
    en: {
      heroTitle: "raneen Selling Fee Structure: grow your business",
      heroText: "The cost to sell on raneen depends on your selling plan, product category, fulfillment strategy, and other services you opt for. The options are flexible, so you can find the combination that works best for you.",
      referralFees: "Commission fees",
      referralFeesText: "raneen charges a commission fee for each item sold. The amount depends on the product category. Most commission fees are between 3% and 15%.",
      seeReferralFees: "See commission fees",
      fulfillmentFees: "Fulfillment fees",
      fulfillmentFeesText: "The cost to ship your orders depends on whether you use Managed by raneen (MBR), Fulfillment by raneen (FBR), or Fulfillment by Seller (FBS).",
      seeFulfillmentFees: "See fulfillment fees",
      otherCosts: "Other costs",
      otherCostsText: "Some sellers may incur additional fees (such as long-term storage fees) or pay for optional programs like advertising.",
      seeOtherCosts: "See other costs",
      gettingPaid: "Getting paid and paying fees",
      gettingPaidText: "When you set up a seller account, you'll provide a credit card number and a bank account. Proceeds from sales will be deposited into your bank account (pre-deducting fees).",
      feeStructure: "Fee Structure",
      feeStructureText: "The fee rates for selling on raneen vary based on the category & fulfillment channel you are using.",
      easyShipFees: "Managed by raneen\n(MBR) Fees",
      selfShipFees: "Fulfillment by Seller\n(FBS) Fees",
      fbrFees: "Fulfillment by raneen\n(FBR) Fees",
      referralFee: "Commission Fee",
      shippingFee: "Shipping Fee",
      fulfillmentFee: "Fulfillment Fee",
      storageFee: "Monthly Storage Fee",
      longTermStorageFee: "Long Term Storage Fee",
      shippingCost: "Shipping Cost",
      referralFeeDesc: "Starting from 3% or min EGP 5, varies by category",
      shippingFeeDesc: "Starts at EGP 42 per shipment, varies by size*",
      shippingFeeNote: "*Sellers can collect a shipping charge from customers up to EGP 26 per shipment",
      selfShipDesc: "Seller handles storing, packing, and shipping your products to customers. Fees vary by size and weight.",
      fbrFulfillmentDesc: "Starts at EGP 15.5 per unit, varies by size",
      storageDesc: "Storage fees based on the daily average volume in cubic foot per month",
      longTermDesc: "Inventory in fulfillment centers for 365+ days incurs a long-term storage fee",
      vatNote: "Note: All listed fees are displayed excluding applicable VAT. VAT will be additionally applied to all fees displayed above.",
      plansTitle: "Selling plans",
      plansText: "Choose the plan that fits your business. Start free and scale when you're ready.",
      plans: [
        {
          name: "Starter",
          price: "EGP 999/mo",
          badge: "",
          desc: "Launch your raneen store with all the essentials.",
          features: [
            "Unlimited monthly sales",
            "Cash on Delivery (COD)",
            "Custom domain",
            "Raya, Movex, RExpress shipping",
          ],
          cta: "Select",
        },
        {
          name: "Growth",
          price: "EGP 2,499/mo",
          badge: "Most popular",
          desc: "Scale sales with more payment options and marketing tools.",
          features: [
            "Everything in Starter",
            "Card payments (Visa/MC/Meeza)*",
            "Instalments (ValU/Souhoola/Aman)*",
            "RExpress priority dispatch",
            "SEO tools",
          ],
          cta: "Select",
        },
        {
          name: "Professional",
          price: "EGP 4,999/mo",
          badge: "",
          desc: "All features to grow your business at the highest level.",
          features: [
            "Everything in Growth",
            "Sell in our stores",
            "AI tools (copy + images)",
            "Free shipping promo tools",
            "Priority payout cycle",
          ],
          cta: "Select",
        },
      ],
      categoryFeesTitle: "Category Commission Fees",
      category: "Main Category",
      subCategory: "Subcategory",
      referralFeePercentage: "Commission fee percentage",
      referralFeeMinimum: "Commission fee minimum",
      catalogSyncTitle: "Catalog sync plans",
      catalogSyncSubtitle: "All prices EGP / month",
      catalogSyncPlans: [
        { name: "Monthly", price: "499", currency: "EGP", syncs: "1 sync / month", perSync: "499 per sync", cta: "Select" },
        { name: "Bi-weekly", price: "749", currency: "EGP", syncs: "2 syncs / month", perSync: "375 per sync", cta: "Select" },
        { name: "Weekly", price: "999", currency: "EGP", syncs: "~4 syncs / month", perSync: "250 per sync", cta: "Select", badge: "Most popular" },
        { name: "Daily", price: "1,499", currency: "EGP", syncs: "~30 syncs / month", perSync: "50 per sync", cta: "Select" },
      ],
      payAsYouGoLabel: "No subscription",
      payAsYouGoTitle: "Pay as you go",
      payAsYouGoDesc: "One-time catalog scrape. Snapshot only — no ongoing sync.",
      payAsYouGoPrice: "EGP 15",
      payAsYouGoUnit: "per product (any count of SKUs)",
      compareTitle: "Compare all features",
      compareFeatureCol: "Feature",
      compareRows: [
        { feature: "Monthly sales", free: "Unlimited", scale: "Unlimited", pro: "Unlimited" },
        { feature: "Cash on Delivery (COD)", free: true, scale: true, pro: true },
        { feature: "Card payments (Visa/MC/Meeza)*", free: false, scale: true, pro: true },
        { feature: "Instalments (ValU/Souhoola/Aman)*", free: false, scale: true, pro: true },
        { feature: "Faster payout cycle", free: false, scale: "Standard", pro: "Priority" },
        { feature: "Custom domain", free: true, scale: true, pro: true },
        { feature: "Shipping partners (Raya, Movex, RExpress)", free: true, scale: true, pro: true },
        { feature: "RExpress priority dispatch", free: false, scale: true, pro: true },
        { feature: "Free shipping promo tools", free: false, scale: false, pro: true },
        { feature: "SEO tools", free: false, scale: true, pro: true },
        { feature: "AI tools (product copy, image enhance)", free: false, scale: false, pro: true },
      ],
      compareFootnote: "* Payment processing fees apply per transaction. All prices exclude VAT (14%).",
    },
  },

  // ===== RETAIL PAGE =====
  retailPage: {
    ar: {
      eyebrow: "الخطط",
      title: "ثلاث درجات لتشغيل تجزئتك بالكامل",
      subtitle:
        "السعر الأساسي شهري بالجنيه المصري وشامل الدفع عند الاستلام. تُضاف رسوم استهلاك الـ SKU وقنوات الإيراد الاختيارية حسب نموّك.",
      collapse: { hide: "إخفاء", show: "عرض" },
      compareTitle: "مقارنة تفصيلية بين الخطط",
      compareFeatureCol: "الميزة",
      pdf: {
        cta: "تحميل الخطط PDF",
        loading: "جاري التحضير…",
        note: "حمّل ملف PDF يشمل الخطط والمقارنة التفصيلية لمشاركته مع فريقك.",
        fileName: "خطط-رنين-للتجزئة.pdf",
      },

      tiers: [
        {
          id: "growth",
          name: "نُمُوّ",
          latin: "Growth",
          who: "ابنِ متجرك بعلامتك التجارية ودومينك الخاص، مع أدوات ذكاء اصطناعي لتسريع البيع.",
          price: "٢٤٬٩٩٩",
          currency: "ج.م",
          per: "/شهر",
          meta: "حتى ٥٠٠ SKU · متعدد القنوات",
          cta: "ابنِ متجرك",
          label: "جاهز في 24 ساعة",

          features: [
            { text: "متجر مستقل بعلامتك ودومينك" },
            { text: "دفع عند الاستلام + بطاقات + محافظ" },
            { text: "منصة إعلانات (ميتا، جوجل، تيكتوك)" },
            { text: "توليد محتوى بالذكاء الاصطناعي" },
            { text: "تأكيد الطلبات عبر واتساب" },
            { text: "ربط بشركات الشحن" },
          ],
        },
        {
          id: "professional",
          name: "احتراف",
          latin: "Professional",
          who: "للتجار متعددي الفروع — حوّل متجرك إلى منصة إعلانات تربح منها.",
          price: "٤٩٬٩٩٩",
          currency: "ج.م",
          per: "/شهر",
          meta: "SKU غير محدود · متعدد المخازن",
          cta: "وسّع عملياتك",
          featured: true,
          badge: "الأكثر اختيارًا",
          label: "جاهز في 24 ساعة",
          features: [
            { text: "كل ما في «نُمُوّ» +", bold: true },
            { text: "متعدد الفروع والمخازن" },
            { text: "مراقبة الأسعار والتنبيهات" },
            { text: "خدمة عملاء مخصّصة لك" },
            { text: "مدير نجاح مخصّص" },
          ],
        },
        {
          id: "enterprise",
          name: "مؤسسات",
          latin: "Enterprise",
          who: "لسلاسل التجزئة والعلامات الكبرى — تكامل ERP واتفاقية مستوى خدمة.",
          price: "حسب الطلب",
          meta: "تسعير وعقد مُفصّل",
          cta: "تواصل مع المبيعات",
          label: "انطلق خلال أسبوع واحد",
          features: [
            { text: "كل ما في «احتراف» +", bold: true },
            { text: "شحن سريع / نفس اليوم" },
            { text: "تكامل ERP (D365 / Odoo)" },
            { text: "Headless / API كامل" },
          ],
        },
      ],

      groups: [
        {
          title: "المنصّة الأساسية",
          rows: [
            { label: "متجر مستقل بعلامتك ودومينك", values: [true, true, true] },
            { label: "مدة الإطلاق", values: ["24 ساعة", "24 ساعة", "أسبوع واحد"] },
            { label: "توليد محتوى بالذكاء الاصطناعي", values: [true, true, true] },
            { label: "حد الـ SKU", values: ["حتى ٥٠٠", "غير محدود", "غير محدود"] },
            { label: "متعدد الفروع والمخازن", values: [false, true, true] },
          ],
        },
        {
          title: "القنوات والطلب",
          rows: [
            { label: "دفع عند الاستلام + بطاقات + محافظ", values: [true, true, true] },
            { label: "تأكيد الطلبات عبر واتساب", values: [true, true, true] },
          ],
        },
        {
          title: "الإعلانات والشحن",
          rows: [
            { label: "منصة إعلانات (ميتا، جوجل، تيكتوك)", values: [true, true, true] },
            { label: "ربط بشركات الشحن", values: [true, true, true] },
            { label: "شحن سريع / نفس اليوم", values: [false, false, true] },
          ],
        },
        {
          title: "الذكاء",
          rows: [
            { label: "مراقبة الأسعار والتنبيهات", values: [false, true, true] },
          ],
        },
        {
          title: "الدعم والتكامل",
          rows: [
            { label: "خدمة عملاء مخصّصة لك", values: [false, true, true] },
            { label: "مدير نجاح مخصّص", values: [false, true, true] },
            { label: "تكامل ERP (D365 / Odoo)", values: [false, false, true] },
            { label: "Headless / API كامل", values: [false, false, true] },
          ],
        },
      ],


    },
    en: {
      eyebrow: "Plans",
      title: "Three tiers to run your retail end-to-end",
      subtitle:
        "Base price is monthly in Egyptian Pounds and includes Cash on Delivery. SKU usage and optional revenue channel fees are added as you grow.",
      collapse: { hide: "Hide", show: "Show" },
      compareTitle: "Detailed plan comparison",
      compareFeatureCol: "Feature",
      pdf: {
        cta: "Download plans as PDF",
        loading: "Preparing…",
        note: "Get a PDF with all plans and the detailed comparison to share with your team.",
        fileName: "raneen-retail-plans.pdf",
      },

      tiers: [
        {
          id: "growth",
          name: "Growth",
          latin: "",
          who: "Build your branded store with your own domain, powered by AI tools to start selling faster.",
          price: "24,999",
          currency: "EGP",
          per: "/mo",
          meta: "Up to 500 SKUs · multi-channel",
          cta: "Build your store",
          label: "Go live in 24 hours",
          features: [
            { text: "Standalone store with your brand and domain" },
            { text: "Cash on delivery + cards + wallets" },
            { text: "Ads platform (Meta, Google, TikTok)" },
            { text: "Egyptian Arabic AI content generation" },
            { text: "Confirm orders via WhatsApp" },
            { text: "Connected with shipping companies" },
          ],
        },
        {
          id: "professional",
          name: "Professional",
          latin: "",
          who: "For multi-branch sellers — turn your store into an ads platform.",
          price: "49,999",
          currency: "EGP",
          per: "/mo",
          meta: "Unlimited SKUs · multi-warehouse",
          cta: "Expand operations",
          featured: true,
          badge: "Most popular",
          label: "Go live in 24 hours",
          features: [
            { text: "Everything in Growth +", bold: true },
            { text: "Multi-branch & multi-warehouse" },
            { text: "Price Tracking & Alerts" },
            { text: "Dedicated call center" },
            { text: "Dedicated success manager" },
          ],
        },
        {
          id: "enterprise",
          name: "Enterprise",
          latin: "",
          who: "For retail chains and major brands — ERP integration and SLA.",
          price: "Custom",
          meta: "Custom pricing & contract",
          cta: "Contact sales",
          label: "Go live in 1 week",
          features: [
            { text: "Everything in Professional +", bold: true },
            { text: "Fast / same-day delivery" },
            { text: "ERP integration (D365 / Odoo)" },
            { text: "Full headless / API" },
          ],
        },
      ],
      groups: [
        {
          title: "Core platform",
          rows: [
            { label: "Standalone store with your brand and domain", values: [true, true, true] },
            { label: "Time to go live", values: ["24 hours", "24 hours", "1 week"] },
            { label: "Egyptian Arabic AI content generation", values: [true, true, true] },
            { label: "SKU limit", values: ["Up to 500", "Unlimited", "Unlimited"] },
            { label: "Multi-branch & multi-warehouse", values: [false, true, true] },
          ],
        },
        {
          title: "Channels & orders",
          rows: [
            { label: "Cash on delivery + cards + wallets", values: [true, true, true] },
            { label: "Confirm orders via WhatsApp", values: [true, true, true] },
          ],
        },
        {
          title: "Ads & shipping",
          rows: [
            { label: "Ads platform (Meta, Google, TikTok)", values: [true, true, true] },
            { label: "Connected with shipping companies", values: [true, true, true] },
            { label: "Fast / same-day delivery", values: [false, false, true] },
          ],
        },
        {
          title: "Intelligence",
          rows: [
            { label: "Price Tracking & Alerts", values: [false, true, true] },
          ],
        },
        {
          title: "Support & integration",
          rows: [
            { label: "Dedicated call center", values: [false, true, true] },
            { label: "Dedicated success manager", values: [false, true, true] },
            { label: "ERP integration (D365 / Odoo)", values: [false, false, true] },
            { label: "Full headless / API", values: [false, false, true] },
          ],
        },
      ],

    },
  },



  // ===== LEARN PAGE =====
  learnPage: {
    ar: {
      heroTitle: "اتعلم إزاي تبدأ متجر رنين: ابدأ رحلتك كبائع",
      heroText: "كتير من بائعين رنين رواد أعمال — بيبدأوا متجر على رنين في مصر، بيبنوا وبيبتكروا وبيجربوا. مفيش حاجة من دي سهلة، بس إحنا هنا نساعدك بمكتبة بتكبر من الموارد المجانية عشان توجهك للنجاح.",
      sellerUniversity: "جامعة البائع",
      sellerUniversityText: "اتقن أدوات البيع المتاحة ليك بمساعدة الفيديوهات التعليمية بتاعتنا.",
      sellerUniversityLearn: "اعرف أكتر عن جامعة البائع",
      faqs: "أسئلة شائعة",
      faqsText: "لاقي إجابات للأسئلة اللي بنسمعها كتير من البائعين.",
      goToFaqs: "روح للأسئلة الشائعة",
      otherResources: "موارد تانية",
      otherResourcesText: "اعرف أكتر عن إزاي تبدأ متجر رنين في مصر من خلال صفحات المساعدة والندوات والأدلة.",
      findResources: "لاقي موارد تانية",
      whatIsSellerUniversity: "إيه هي جامعة البائع؟",
      sellerUniversityDesc: "أهلاً بيك في جامعة البائع - مركز التعلم الشامل لنجاحك على رنين. المنصة المجانية دي بترشدك خلال كل خطوة في رحلة البيع، من إطلاق متجرك لتوسيع شغلك.",
      sellerUniversityDetails: "فيديوهاتنا اللي بيقودها خبراء بتغطي كل حاجة محتاج تعرفها عن إعداد متجرك على رنين وإنشاء قوائم منتجات جذابة. هتتقن أدوات البائع الأساسية وتتعلم إرشادات المنتج المهمة. اكتشف إزاي تحسّن شغلك مع التوصيل عن طريق رنين (FBR)، واتعلم استراتيجيات فعالة للإعلان والعروض الترويجية.",
      faqTitle: "أسئلة شائعة",
      faqSubtitle: "خد إجابات للأسئلة الشائعة عن استخدام رنين للتجارة الإلكترونية.",
      faqCategories: {
        overview: "نظرة عامة",
        pricing: "الأسعار",
        selling: "البيع",
      },
      faqItems: [
        { q: "إيه هو البيع على رنين؟", a: "البيع على رنين هو برنامج بيتيح للأفراد وأصحاب البيزنس يبيعوا منتجاتهم على متاجر رنين." },
        { q: "ليه لازم أبيع على رنين؟", a: "فرصة تعرض منتجك قدام ملايين العملاء المحتملين، وكمان تقدر تبدأ بيع بسرعة قبل ما تعمل موقع أو محل." },
        { q: "أقدر أدرج منتجاتي في كل فئات رنين؟", a: "ممكن تحتاج موافقة مسبقة عشان تدرج منتجات معينة في فئات معينة." },
        { q: "بكام البيع على رنين؟", a: "الحسابات الاحترافية متاحة دلوقتي كعرض لفترة محدودة بخصم 50% على رسوم الاشتراك الشهري. ممكن تنطبق رسوم إحالة لكل وحدة تتباع." },
        { q: "إزاي أستلم فلوسي؟", a: "لما حسابك كبائع يتسوّى ويكون عندك رصيد إيجابي، رنين بتبعت الفلوس لحسابك البنكي بتحويل إلكتروني. ممكن ياخد لحد 5 أيام عمل." },
        { q: "إزاي أدير حساب البيع بتاعي؟", a: "استخدم موقع لوحة تحكم البائع عشان تدير كل حاجة في شغلك على رنين. لوحة التحكم هي المكان اللي بتدير فيه حسابك وتضيف معلومات المنتج وتحدّث المخزون وتدير الطلبات والمدفوعات." },
        { q: "إزاي أضيف المخزون؟", a: "عندك كذا خيار: استخدم ميزة إضافة منتج في لوحة تحكم البائع، استخدم ملفات المخزون بصيغة Excel عشان تضيف قوائم كتير مرة واحدة، أو استخدم API للتحميل بالجملة." },
        { q: "إزاي بيشتغل التوصيل عن طريق رنين؟", a: "مع التوصيل عن طريق رنين (FBR) بتخزّن منتجاتك في مراكز توصيل رنين، وإحنا بنتولى الاختيار والتعبئة والشحن وخدمة العملاء." },
      ],
      otherResourcesTitle: "موارد تانية",
      webinarsEvents: "ندوات وفعاليات رنين",
      webinarsEventsText: "انضم لندواتنا وورش العمل عشان تتعلم إزاي تبدأ متجر رنين في مصر وتحسّنه وتوصله للنجاح.",
      sellerHelp: "مساعدة البائع",
      sellerHelpText: "ادخل بعمق في مواضيع محددة متعلقة بالبيع على رنين.",
      beginnersGuide: "دليل المبتدئين",
      beginnersGuideText: "اكتشف إيه اللي محتاجه عشان تبدأ متجر رنين في مصر وتبدأ بيع.",
    },
    en: {
      heroTitle: "Learn How to Start a raneen Store: Kickstart your journey as a seller",
      heroText: "Many raneen sellers are entrepreneurs—starting a raneen store in Egypt, building, inventing, and experimenting. None of that is easy, but we're here to help you with a growing library of free resources to guide you toward success.",
      sellerUniversity: "Seller University",
      sellerUniversityText: "Master the selling tools at your disposal with the help of our tutorial videos.",
      sellerUniversityLearn: "Learn about Seller University",
      faqs: "FAQs",
      faqsText: "Find answers to the most common questions we receive from sellers.",
      goToFaqs: "Go to FAQs",
      otherResources: "Other Resources",
      otherResourcesText: "Gain more knowledge about how to start a raneen store in Egypt by getting access to help pages, webinars, and guides.",
      findResources: "Find other resources",
      whatIsSellerUniversity: "What is Seller University?",
      sellerUniversityDesc: "Welcome to Seller University - your comprehensive learning hub for raneen success. This free video platform guides you through every step of your selling journey, from launching your store to scaling your business.",
      sellerUniversityDetails: "Our expert-led videos cover everything you need to know about setting up your raneen store and creating compelling product listings. You'll master essential seller tools and learn crucial product guidelines. Discover how to optimize your business with Fulfillment by raneen (FBR), and learn effective strategies for advertising and promotions.",
      faqTitle: "Frequently Asked Questions",
      faqSubtitle: "Get answers to frequently asked questions about using raneen for ecommerce.",
      faqCategories: {
        overview: "Overview",
        pricing: "Pricing",
        selling: "Selling",
      },
      faqItems: [
        { q: "What is selling on raneen?", a: "Selling on raneen is a program that allows individuals and business owners to sell their products on raneen's stores." },
        { q: "Why should I sell on raneen?", a: "The opportunity to put your product in front of millions of potential customers, plus the ability to start selling fast before you even set up a business website or physical store." },
        { q: "Can I list my products in all raneen categories?", a: "Prior approval may be required to list certain products in certain categories." },
        { q: "How much does it cost to sell on raneen?", a: "Professional accounts are now available at a promotion for limited time only, with 50% discount on monthly subscription fee. Commission fees per unit sold and other costs may apply." },
        { q: "How do I get paid?", a: "When your seller account is settled and you have a positive balance, raneen sends the money to your bank account using electronic funds transfer. It can take up to five business days." },
        { q: "How do I manage my selling account?", a: "Use the Seller Central website to manage all parts of your raneen business. Seller Central is where you manage your selling account, add product information, make inventory updates, and manage orders and payments." },
        { q: "How do I add inventory?", a: "You have multiple options: Use the Add a Product feature on Seller Central, use Excel-based inventory files to add multiple listings at once, or use API for bulk uploads." },
        { q: "How does Fulfillment by raneen work?", a: "With Fulfillment by raneen (FBR) you store your products in raneen's fulfillment centers, and we pick, pack, ship, and provide customer service for these products." },
      ],
      otherResourcesTitle: "Other Resources",
      webinarsEvents: "raneen Webinars and Events",
      webinarsEventsText: "Join our webinars and workshops to learn how to start a raneen store in Egypt, optimize it, and lead it to success.",
      sellerHelp: "Seller Help",
      sellerHelpText: "Dive deep on specific topics related to selling on raneen.",
      beginnersGuide: "The Beginner's Guide",
      beginnersGuideText: "Find out what you'll need to start a raneen store in Egypt to begin selling.",
    },
  },

  // ===== WHAT TO SELL PAGE =====
  whatToSellPage: {
    ar: {
      heroTitle: "إيه تبيع على رنين مصر",
      heroText: "مش متأكد إيه المنتجات اللي تبيعها؟ اكتشف أكتر الفئات طلباً واتعلم إزاي تلاقي منتجات مربحة.",
      trendingTitle: "فئات رائجة",
      trendingText: "الفئات دي فيها طلب عالي من العملاء على رنين دلوقتي.",
      categories: [
        { name: "إلكترونيات واكسسوارات", desc: "موبايلات، لابتوبات، سماعات، وملحقات إلكترونية" },
        { name: "منزل ومطبخ", desc: "أجهزة منزلية، أدوات مطبخ، ومستلزمات المنزل" },
        { name: "تجميل وعناية شخصية", desc: "مكياج، عناية بالبشرة، والعطور" },
        { name: "ملابس وأزياء", desc: "ملابس رجالي ونسائي واطفال" },
        { name: "رياضة ولياقة", desc: "أجهزة رياضية ومستلزمات اللياقة" },
        { name: "ألعاب ومستلزمات أطفال", desc: "ألعاب تعليمية ومستلزمات الأطفال" },
      ],
      sourcingTitle: "إزاي تلاقي منتجات",
      sourcingMethods: [
        { title: "إعادة البيع", desc: "اشتري منتجات بالجملة وبيعها على رنين بربح." },
        { title: "العلامة الخاصة", desc: "صنّع منتجاتك الخاصة تحت البراند بتاعك." },
        { title: "دروبشيبينغ", desc: "بيع منتجات من غير ما تخزنها - المورد بيشحن مباشرة." },
        { title: "صناعة يدوية", desc: "اصنع منتجات فريدة يدوياً وبيعها على رنين." },
      ],
      tipsTitle: "نصايح لاختيار المنتج",
      tips: [
        "دوّر على منتجات عليها طلب عالي ومنافسة قليلة",
        "اختار منتجات بهامش ربح كويس بعد خصم كل التكاليف",
        "تأكد إن المنتج سهل الشحن ومش هش",
        "اقرأ تقييمات المنافسين عشان تلاقي فرص تحسين",
      ],
    },
    en: {
      heroTitle: "What to Sell on raneen Egypt",
      heroText: "Not sure what products to sell? Discover the most in-demand categories and learn how to find profitable products.",
      trendingTitle: "Trending Categories",
      trendingText: "These categories are experiencing high customer demand on raneen right now.",
      categories: [
        { name: "Electronics & Accessories", desc: "Phones, laptops, headphones, and electronic accessories" },
        { name: "Home & Kitchen", desc: "Home appliances, kitchen tools, and household essentials" },
        { name: "Beauty & Personal Care", desc: "Makeup, skincare, and fragrances" },
        { name: "Clothing & Fashion", desc: "Men's, women's, and kids' apparel" },
        { name: "Sports & Fitness", desc: "Sports equipment and fitness gear" },
        { name: "Toys & Baby Products", desc: "Educational toys and baby essentials" },
      ],
      sourcingTitle: "How to Source Products",
      sourcingMethods: [
        { title: "Reselling", desc: "Buy products wholesale and sell them on raneen at a profit." },
        { title: "Private Label", desc: "Manufacture your own products under your brand." },
        { title: "Dropshipping", desc: "Sell products without holding inventory — the supplier ships directly." },
        { title: "Handmade", desc: "Create unique handmade products and sell them on raneen." },
      ],
      tipsTitle: "Tips for Choosing Products",
      tips: [
        "Look for products with high demand and low competition",
        "Choose products with good profit margins after all costs",
        "Make sure the product is easy to ship and not fragile",
        "Read competitor reviews to find improvement opportunities",
      ],
    },
  },

  // ===== SUPPLY CHAIN PAGE =====
  supplyChainPage: {
    ar: {
      heroTitle: "حلول سلسلة التوريد من رنين",
      heroText: "من المصنع للعميل - حلول لوجستية شاملة تساعدك تدير شغلك بكفاءة أعلى وتكلفة أقل.",
      servicesTitle: "خدماتنا اللوجستية",
      services: [
        { title: "التخزين", desc: "خزّن منتجاتك في مراكز توصيل رنين المنتشرة في مصر. نظام إدارة مخزون متقدم." },
        { title: "إدارة المخزون", desc: "تتبع مخزونك في الوقت الحقيقي واحصل على تنبيهات ذكية لإعادة الطلب." },
        { title: "التعبئة والتغليف", desc: "خدمات تعبئة وتغليف احترافية تحافظ على منتجاتك وتعكس جودة البراند بتاعك." },
        { title: "توصيل الميل الأخير", desc: "شبكة توصيل واسعة تغطي كل محافظات مصر بأسرع وقت ممكن." },
      ],
      benefitsTitle: "ليه تختار سلسلة توريد رنين؟",
      benefits: [
        "توفير في التكاليف اللوجستية لحد 40%",
        "شبكة توصيل تغطي كل مصر",
        "نظام تتبع متقدم في الوقت الحقيقي",
        "خدمة عملاء ومرتجعات مُدارة بالكامل",
      ],
    },
    en: {
      heroTitle: "raneen Supply Chain Solutions",
      heroText: "From factory to customer — comprehensive logistics solutions that help you run your business more efficiently at lower cost.",
      servicesTitle: "Our Logistics Services",
      services: [
        { title: "Warehousing", desc: "Store your products in raneen fulfillment centers across Egypt. Advanced inventory management system." },
        { title: "Inventory Management", desc: "Track your inventory in real-time and get smart alerts for reordering." },
        { title: "Packaging", desc: "Professional packaging services that protect your products and reflect your brand quality." },
        { title: "Last-Mile Delivery", desc: "Wide delivery network covering all Egyptian governorates in the fastest time possible." },
      ],
      benefitsTitle: "Why Choose raneen Supply Chain?",
      benefits: [
        "Up to 40% savings on logistics costs",
        "Delivery network covering all of Egypt",
        "Advanced real-time tracking system",
        "Fully managed customer service and returns",
      ],
    },
  },

  // ===== SELLER STORIES PAGE =====
  sellerStoriesPage: {
    ar: {
      heroTitle: "قصص نجاح بائعين رنين",
      heroText: "اسمع من بائعين حققوا نجاح كبير على رنين. قصصهم ممكن تلهمك تبدأ رحلتك.",
      stories: [
        {
          slug: "dukan-alaa",
          name: "صاحب - دكان علاء",
          role: "علاء الدين",
          quote: "الذكاء الاصطناعي في لوحة التحكم الجديدة من رنين غيّر شغلنا بالكامل. بقينا بنفهم عملاءنا أكتر وبنبيع أحسن.",
          stat: "+97%",
          statLabel: "نمو سنوي",
          story: "بدأنا بدكان صغير وكنا بنبيع في منطقتنا بس. لما انضمينا لرنين واستخدمنا أدوات الذكاء الاصطناعي في لوحة التحكم الجديدة، قدرنا نحلّل سلوك العملاء ونعدّل أسعارنا ومنتجاتنا على أساس بيانات حقيقية. النتيجة كانت نمو 97% في المبيعات خلال سنة واحدة.",
          videoUrl: "https://www.youtube.com/watch?v=FdxeIAP1Fps",
          videoCaption: "شوف قصة علاء كاملة",
          uploadDate: "2024-06-15",
        },
        {
          slug: "craft-furniture",
          name: "صاحب - كرافت للأثاث",
          role: "مصطفى عبدالحميد",
          quote: "رنين إدتنا الفرصة نتصرف زي براند كبير. بيوفرولنا كل الدعم وإحنا بنقدم أحسن المنتجات لعملاءنا.",
          stat: "233%",
          statLabel: "نمو المبيعات ٢٠٢٥ مقابل ٢٠٢٦",
          story: "بدأنا كرافت للأثاث كمحل صغير، ولما انضمينا لرنين قدرنا نوصل لعملاء جدد في كل مصر ونبني براند قوي. النتيجة كانت نمو 233% في المبيعات بين 2025 و2026.",
          videoUrl: "https://www.youtube.com/watch?v=bRXO2aZ8eKc",
          videoCaption: "شوف قصة كرافت للأثاث كاملة",
          uploadDate: "2024-07-20",
        },
        {
          slug: "al-andalos-air-conditioner",
          name: "صاحب - الأندلس للتكييفات",
          role: "زيد علي",
          quote: "إحنا مبسوطين إن فلوس مبيعاتنا بتوصلنا بسرعة، ده بيخلينا نقدر ندير المشتريات والكاش فلو بتاعنا كويس.",
          stat: "160%",
          statLabel: "معدل النمو السنوي المركب لسنتين",
          story: "عندنا محل تكييفات صغير. كنا بنبيع في منطقتنا بس. لما بدأنا نبيع على رنين ماركت بليس، قدرنا نوصل لكل مصر من غير ما نشيل هم الشحن لاكتر من ٢٦ محافظة.",
          videoUrl: "https://www.youtube.com/watch?v=DkCvXdVZiK0",
          videoCaption: "شوف قصة زيد كاملة",
          uploadDate: "2024-08-10",
        },
      ],
    },
    en: {
      heroTitle: "raneen Seller Success Stories",
      heroText: "Hear from sellers who achieved great success on raneen. Their stories can inspire you to start your journey.",
      stories: [
        {
          slug: "dukan-alaa",
          name: "Owner - Dukan Alaa",
          role: "Alaa El Din",
          quote: "The AI built into raneen's new dashboard transformed how we operate. We understand our customers better and sell smarter.",
          stat: "+97%",
          statLabel: "Year-over-year growth",
          story: "We started as a small shop selling locally. After joining raneen and tapping into the AI tools in the new dashboard, we could analyze customer behavior and tune our pricing and assortment based on real data. The result was 97% year-over-year sales growth.",
          videoUrl: "https://www.youtube.com/watch?v=FdxeIAP1Fps",
          videoCaption: "Watch Alaa's full story",
          uploadDate: "2024-06-15",
        },
        {
          slug: "craft-furniture",
          name: "Owner - Craft Furniture",
          role: "Mustafa Abdelhamid",
          quote: "raneen gave us the opportunity to act like a big brand. They provide all the support and we deliver our best products.",
          stat: "233%",
          statLabel: "Sales growth 2025 vs 2026",
          story: "We started Craft Furniture as a small shop. After joining raneen, we reached new customers across Egypt and built a strong brand. The result was 233% sales growth between 2025 and 2026.",
          videoUrl: "https://www.youtube.com/watch?v=bRXO2aZ8eKc",
          videoCaption: "Watch Craft Furniture's full story",
          uploadDate: "2024-07-20",
        },
        {
          slug: "al-andalos-air-conditioner",
          name: "Owner - Al Andalos for Air Conditioner",
          role: "Zaid Ali",
          quote: "We are happy that we receive our sales cash very fast so we can manage our buying & cash flow.",
          stat: "160%",
          statLabel: "2-years CAGR",
          story: "We have a small air conditioner shop. We used to sell locally only. When we started selling on raneen Marketplace, we could reach all of Egypt without worrying about shipping to more than 26 governorates.",
          videoUrl: "https://www.youtube.com/watch?v=DkCvXdVZiK0",
          videoCaption: "Watch Zaid's full story",
          uploadDate: "2024-08-10",
        },
      ],
    },
  },

  // ===== OPTIONAL COSTS PAGE =====
  optionalCostsPage: {
    ar: {
      heroTitle: "التكاليف الإضافية والخدمات الاختيارية",
      heroText: "بالإضافة لرسوم البيع الأساسية، ممكن تختار خدمات إضافية لتكبير شغلك. كل الخدمات دي اختيارية.",
      costsTitle: "الخدمات الاختيارية",
      costs: [
        { title: "الإعلانات المموّلة", desc: "ابدأ من 10 جنيه/يوم. ادفع بس لما حد يضغط على إعلانك.", price: "من 10 جنيه/يوم" },
        { title: "التخزين طويل الأجل", desc: "المخزون اللي في مراكز التوصيل لأكتر من 365 يوم بيتحمل رسوم إضافية.", price: "بيختلف" },
        { title: "خدمات التصوير", desc: "صور منتجاتك باحترافية في استوديو رنين.", price: "من 50 جنيه/منتج" },
        { title: "محتوى A+", desc: "حسّن صفحات منتجاتك بمحتوى غني وصور إضافية.", price: "مجاني مع البراند" },
        { title: "إزالة المخزون", desc: "طلب إرجاع أو التخلص من المخزون في مراكز التوصيل.", price: "من 5 جنيه/وحدة" },
        { title: "تغليف مخصص", desc: "غلّف منتجاتك بتغليف يحمل البراند بتاعك.", price: "من 3 جنيه/وحدة" },
      ],
      noteTitle: "ملاحظة مهمة",
      noteText: "كل الأسعار المذكورة قابلة للتغيير ومعروضة من غير ضريبة القيمة المضافة. راجع لوحة تحكم البائع للأسعار المحدثة.",
    },
    en: {
      heroTitle: "Optional Costs & Additional Services",
      heroText: "In addition to standard selling fees, you can opt into additional services to grow your business. All these services are optional.",
      costsTitle: "Optional Services",
      costs: [
        { title: "Sponsored Ads", desc: "Start from EGP 10/day. Pay only when someone clicks your ad.", price: "From EGP 10/day" },
        { title: "Long-Term Storage", desc: "Inventory in fulfillment centers for 365+ days incurs additional fees.", price: "Varies" },
        { title: "Photography Services", desc: "Get your products professionally photographed in raneen's studio.", price: "From EGP 50/product" },
        { title: "A+ Content", desc: "Enhance your product pages with rich content and additional images.", price: "Free with Brand Registry" },
        { title: "Inventory Removal", desc: "Request return or disposal of inventory in fulfillment centers.", price: "From EGP 5/unit" },
        { title: "Custom Packaging", desc: "Package your products with branded packaging.", price: "From EGP 3/unit" },
      ],
      noteTitle: "Important Note",
      noteText: "All prices listed are subject to change and displayed excluding VAT. Check Seller Central for the most up-to-date pricing.",
    },
  },

  // ===== GET THE APP PAGE =====
  getAppPage: {
    ar: {
      heroTitle: "حمّل تطبيق بائعي رنين",
      heroText: "دير متجرك من أي مكان وفي أي وقت. تابع مبيعاتك، إدارة الطلبات، والمخزون من على موبايلك.",
      featuresHeading: "إيه اللي تقدر تعمله بالتطبيق؟",
      features: {
        manageOrders: { title: "إدارة الطلبات", text: "تابع طلباتك الجديدة، جهّزها للشحن، وحدّث حالتها بضغطة زرار." },
        trackSales: { title: "متابعة المبيعات", text: "شوف إحصائيات مبيعاتك اليومية والشهرية واعرف أكتر المنتجات مبيعاً." },
        notifications: { title: "تنبيهات فورية", text: "استلم إشعارات لحظية لكل طلب جديد، رسالة عميل، أو تحديث مهم." },
        inventory: { title: "التحكم في المخزون", text: "حدّث كميات منتجاتك، أضف منتجات جديدة، وتابع المخزون اللي خلص." },
        support: { title: "دعم مباشر", text: "تواصل مع فريق دعم البائعين واحصل على إجابات لأسئلتك في أي وقت." },
        payments: { title: "متابعة المدفوعات", text: "تابع تحويلاتك البنكية ورصيدك من المبيعات بكل سهولة وشفافية." },
      },
      ctaTitle: "ابدأ دلوقتي",
      ctaText: "حمّل تطبيق بائعي رنين ببلاش على موبايلك وادير بيزنسك من أي مكان.",
    },
    en: {
      heroTitle: "Download the raneen Seller App",
      heroText: "Manage your store from anywhere, anytime. Track sales, handle orders, and manage inventory right from your phone.",
      featuresHeading: "What you can do with the app",
      features: {
        manageOrders: { title: "Manage Orders", text: "Track new orders, prepare them for shipping, and update their status with a tap." },
        trackSales: { title: "Track Sales", text: "View daily and monthly sales statistics and see your best-selling products." },
        notifications: { title: "Instant Alerts", text: "Get real-time notifications for every new order, customer message, or important update." },
        inventory: { title: "Inventory Control", text: "Update product quantities, add new items, and track out-of-stock inventory." },
        support: { title: "Live Support", text: "Connect with our seller support team and get answers to your questions anytime." },
        payments: { title: "Payment Tracking", text: "Track your bank transfers and sales balance easily and transparently." },
      },
      ctaTitle: "Get started now",
      ctaText: "Download the raneen Seller App for free on your phone and manage your business from anywhere.",
    },
  },

  // ===== SELLER EVENT PAGE =====
  sellerEventPage: {
    ar: {
      eyebrow: "قمة بائعي رنين 2026",
      heroTitle: "ليلة احتفلنا فيها بأبطال البيع في رنين",
      heroSubtitle: "أكتر من 200 بائع، 10+ شركاء، و13 تكريم — في أكبر تجمع لبائعي رنين على الإطلاق.",
      watchCta: "اتفرج على الفيديو",
      registerCta: "سجّل كبائع رنين",
      videoCaption: "فيديو ملخص قمة 2026 — 1:24 دقيقة",
      statsTitle: "القمة بالأرقام",
      stats: [
        { value: "200+", label: "بائع حضر" },
        { value: "27", label: "محافظة ممثلة" },
        { value: "10+", label: "شركاء" },
        { value: "13", label: "تكريم" },
      ],
      agendaTitle: "أجندة اليوم",
      agendaSubtitle: "يوم كامل من المحتوى العملي والإلهام",
      agenda: [
        { time: "9:00 ص", title: "تسجيل وإفطار للضيوف", desc: "استقبال البائعين وإفطار صباحي شبكي." },
        { time: "10:00 ص", title: "كلمة افتتاح القيادة", desc: "مدحت موسى يفتتح القمة برؤية رنين للبائعين في 2026." },
        { time: "11:00 ص", title: "ورش عمل متوازية", desc: "اختار من 12 ورشة: الإعلانات الممولة، FBR، محتوى A+، Brand Registry، والمزيد." },
        { time: "1:30 م", title: "غداء ومعرض الخدمات", desc: "تجربة مباشرة لأدوات لوحة تحكم البائع الجديدة." },
        { time: "3:00 م", title: "جلسة قصص النجاح", desc: "حوار مع أنجح بائعي رنين في 2025." },
        { time: "5:00 م", title: "حفل توزيع جوايز البائعين", desc: "تكريم أفضل 3 بائعين على المنصة." },
      ],
      winnersTitle: "أبطال 2026",
      winnersSubtitle: "تكريم أفضل البائعين أداءً على رنين",
      winners: [
        { name: "كرافت للأثاث", award: "بائع السنة 2026", growth: "نمو 233% في المبيعات", story: "/learn/seller-stories/craft-furniture" },
        { name: "دكان علاء", award: "أفضل استخدام للذكاء الاصطناعي", growth: "نمو 97% سنوي", story: "/learn/seller-stories/dukan-alaa" },
        { name: "الأندلس للتكييفات", award: "أسرع نمو بـ FBR", growth: "نمو 160% سنوي", story: "/learn/seller-stories/al-andalos-air-conditioner" },
      ],
      testimonialsTitle: "البائعين قالوا إيه",
      testimonials: [
        { quote: "أول مرة أحس إن في حد فعلاً بيستثمر في نجاح البائع المصري. خرجت بأفكار قابلة للتنفيذ من أول يوم.", name: "مصطفى عبد الحميد", role: "كرافت للأثاث", avatar: "sara" },
        { quote: "الورش كانت عملية مش نظرية. شغّلت أول حملة إعلانية في نفس الأسبوع وحصلت نتايج حقيقية.", name: "علاء الدين", role: "دكان علاء", avatar: "alaa" },
        { quote: "أحسن جزء كان لقاء بائعين تانيين من نفس المجال. شبكة علاقات حقيقية اتبنت في يوم واحد.", name: "زيد علي", role: "الأندلس للتكييفات", avatar: "mahmoud" },
      ],
      speakersTitle: "المتحدثون",
      speakersSubtitle: "قيادات من رنين والمستشارين اللي رسموا أجندة القمة",
      speakers: [
        { name: "عمرو ابوالعينين", role: "الرئيس التنفيذي وعضو مجلس الإدارة", avatar: "amr" },
        { name: "مؤمن درويش", role: "الرئيس التنفيذي للتكنولوجيا", avatar: "moemen" },
        { name: "رامي وجيه", role: "نائب رئيس القطاع التجاري", avatar: "rami" },
        { name: "فريد غرز الدين", role: "مستشار مجلس الإدارة", avatar: "farid" },
      ],
      attendeesTitle: "من حضر القمة",
      attendeesSubtitle: "جهات حكومية، شركاء وبائعون",
      momentsTitle: "لحظات من القمة",
      ctaTitle: "احجز مكانك في قمة 2027",
      ctaText: "كن جزء من أكبر تجمع لبائعي التجارة الإلكترونية في مصر. سجّل كبائع رنين النهارده عشان نبلغك أول ما يفتح التسجيل.",
      ctaSecondary: "اطلع على قصص النجاح",
    },
    en: {
      eyebrow: "raneen Seller Summit 2026",
      heroTitle: "The night we celebrated Egypt's e-commerce champions",
      heroSubtitle: "Over 200 sellers, 10+ partners, and 13 honors — the largest gathering of raneen sellers ever.",
      watchCta: "Watch the recap",
      registerCta: "Become a raneen seller",
      videoCaption: "Summit 2026 highlight reel — 1:24",
      statsTitle: "The Summit in numbers",
      stats: [
        { value: "200+", label: "sellers attended" },
        { value: "27", label: "governorates represented" },
        { value: "10+", label: "partners" },
        { value: "13", label: "honors" },
      ],
      agendaTitle: "The agenda",
      agendaSubtitle: "A full day of practical content and inspiration",
      agenda: [
        { time: "9:00 AM", title: "Registration & breakfast", desc: "Seller welcome and networking breakfast." },
        { time: "10:00 AM", title: "Leadership keynote", desc: "Medhat Mousa opens the Summit with raneen's seller vision for 2026." },
        { time: "11:00 AM", title: "Parallel workshops", desc: "Choose from 12 workshops: sponsored ads, FBR, A+ Content, Brand Registry and more." },
        { time: "1:30 PM", title: "Lunch & services expo", desc: "Hands-on demos of the new seller dashboard tools." },
        { time: "3:00 PM", title: "Success stories panel", desc: "A conversation with the top-performing raneen sellers of 2025." },
        { time: "5:00 PM", title: "Seller Awards ceremony", desc: "Honoring the top 3 sellers on the platform." },
      ],
      winnersTitle: "2026 champions",
      winnersSubtitle: "Celebrating raneen's top-performing sellers",
      winners: [
        { name: "Craft Furniture", award: "Seller of the Year 2026", growth: "233% sales growth", story: "/learn/seller-stories/craft-furniture" },
        { name: "Dukan Alaa", award: "Best AI Adoption", growth: "97% year-over-year growth", story: "/learn/seller-stories/dukan-alaa" },
        { name: "Al Andalos AC", award: "Fastest Growth with FBR", growth: "160% year-over-year growth", story: "/learn/seller-stories/al-andalos-air-conditioner" },
      ],
      testimonialsTitle: "What sellers said",
      testimonials: [
        { quote: "For the first time I felt that someone is truly investing in the Egyptian seller's success. I left with actionable ideas from day one.", name: "Mustafa Abdelhamid", role: "Craft Furniture", avatar: "sara" },
        { quote: "The workshops were practical, not theoretical. I launched my first ad campaign that same week and got real results.", name: "Alaa El Din", role: "Dukan Alaa", avatar: "alaa" },
        { quote: "The best part was meeting other sellers in my category. Real connections were built in a single day.", name: "Zaid Ali", role: "Al Andalos AC", avatar: "mahmoud" },
      ],
      speakersTitle: "Speakers",
      speakersSubtitle: "Leaders from raneen and our advisors who shaped the Summit agenda",
      speakers: [
        { name: "Amr Aboelinin", role: "CEO & Board Member", avatar: "amr" },
        { name: "Moemen Darwish", role: "Chief Technology Officer", avatar: "moemen" },
        { name: "Rami Wageh", role: "VP of Commercial", avatar: "rami" },
        { name: "Farid Gharazeddine", role: "Board Advisor", avatar: "farid" },
      ],
      attendeesTitle: "Who attended",
      attendeesSubtitle: "Government, partners & sellers",
      momentsTitle: "Summit moments",
      ctaTitle: "Reserve your seat at Summit 2027",
      ctaText: "Be part of Egypt's largest e-commerce seller gathering. Register as a raneen seller today and we'll notify you the moment seats open.",
      ctaSecondary: "Read seller success stories",
    },
  },
} as const;

// Category commission fees data (grouped by main category)
export const categoryFees: {
  mainAr: string;
  mainEn: string;
  items: { subAr: string; subEn: string; percentage: string }[];
}[] = [
  {
    mainAr: "الأزياء",
    mainEn: "Fashion",
    items: [{ subAr: "جميع", subEn: "All", percentage: "20%" }],
  },
  {
    mainAr: "الموبايلات والتابلت",
    mainEn: "Mobiles & Tablets",
    items: [
      { subAr: "الموبايلات", subEn: "Mobile Phones", percentage: "4%" },
      { subAr: "التابلت", subEn: "Tablets", percentage: "4%" },
      { subAr: "الاكسسوارات", subEn: "Accessories", percentage: "15%" },
      { subAr: "ساعات وسماعات ذكية", subEn: "Smart Watches & Headphones", percentage: "8%" },
      { subAr: "هواتف منزلية", subEn: "Home Phones", percentage: "10%" },
    ],
  },
  {
    mainAr: "أجهزة كمبيوتر",
    mainEn: "Computers",
    items: [
      { subAr: "لاب توب", subEn: "Laptops", percentage: "5%" },
      { subAr: "أجهزة كمبيوتر والشاشات", subEn: "Desktops & Monitors", percentage: "8%" },
      { subAr: "قطع غيار واكسسوارات", subEn: "Parts & Accessories", percentage: "10%" },
      { subAr: "هارد درايف ووحدات تخزين", subEn: "Hard Drives & Storage", percentage: "12%" },
      { subAr: "منتجات الشبكات", subEn: "Networking Products", percentage: "12%" },
      { subAr: "البرمجيات", subEn: "Software", percentage: "10%" },
    ],
  },
  {
    mainAr: "طابعات وماسحات ضوئية",
    mainEn: "Printers & Scanners",
    items: [{ subAr: "جميع", subEn: "All", percentage: "6%" }],
  },
  {
    mainAr: "المنزل ومستلزماته",
    mainEn: "Home & Household",
    items: [
      { subAr: "أجهزة منزلية صغيرة", subEn: "Small Home Appliances", percentage: "7%" },
      { subAr: "أجهزة منزلية كبيرة", subEn: "Large Home Appliances", percentage: "4%" },
      { subAr: "الحدائق والحيوانات الأليفة", subEn: "Garden & Pets", percentage: "14%" },
      { subAr: "أجهزة عناية شخصية", subEn: "Personal Care Appliances", percentage: "11%" },
      { subAr: "أدوات منزلية", subEn: "Household Tools", percentage: "20%" },
      { subAr: "المنسوجات والمفروشات", subEn: "Textiles & Furnishings", percentage: "15%" },
    ],
  },
  {
    mainAr: "اكسسوارات الأحذية",
    mainEn: "Shoe Accessories",
    items: [{ subAr: "جميع", subEn: "All", percentage: "15%" }],
  },
  {
    mainAr: "مستلزمات ولعب الأطفال",
    mainEn: "Baby Essentials & Toys",
    items: [
      { subAr: "حديثي الولادة", subEn: "Newborn", percentage: "8%" },
      { subAr: "ألعاب الأطفال", subEn: "Kids' Toys", percentage: "13%" },
    ],
  },
  {
    mainAr: "النظارات",
    mainEn: "Eyewear",
    items: [{ subAr: "جميع", subEn: "All", percentage: "12%" }],
  },
  {
    mainAr: "تلفزيونات",
    mainEn: "Televisions",
    items: [
      { subAr: "تلفزيونات", subEn: "Televisions", percentage: "4%" },
      { subAr: "أجهزة عرض", subEn: "Projectors", percentage: "9%" },
      { subAr: "الاكسسوارات", subEn: "Accessories", percentage: "15%" },
    ],
  },
  {
    mainAr: "كاميرات والاكسسوارات",
    mainEn: "Cameras & Accessories",
    items: [
      { subAr: "كاميرات", subEn: "Cameras", percentage: "6%" },
      { subAr: "الاكسسوارات", subEn: "Accessories", percentage: "15%" },
    ],
  },
  {
    mainAr: "الخزن-خزينة",
    mainEn: "Safes",
    items: [{ subAr: "جميع", subEn: "All", percentage: "12%" }],
  },
  {
    mainAr: "السيارات والأدوات",
    mainEn: "Automotive & Tools",
    items: [{ subAr: "جميع", subEn: "All", percentage: "11%" }],
  },
  {
    mainAr: "ساعات",
    mainEn: "Watches",
    items: [{ subAr: "جميع", subEn: "All", percentage: "12%" }],
  },
  {
    mainAr: "الشنط",
    mainEn: "Bags",
    items: [{ subAr: "جميع", subEn: "All", percentage: "15%" }],
  },
  {
    mainAr: "أجهزة ألعاب إلكترونية",
    mainEn: "Gaming Consoles",
    items: [
      { subAr: "أجهزة ألعاب", subEn: "Gaming Consoles", percentage: "4%" },
      { subAr: "إسطوانات الألعاب", subEn: "Game Discs", percentage: "10%" },
      { subAr: "الاكسسوارات", subEn: "Accessories", percentage: "15%" },
    ],
  },
  {
    mainAr: "الأحذية",
    mainEn: "Shoes",
    items: [{ subAr: "جميع", subEn: "All", percentage: "20%" }],
  },
  {
    mainAr: "الرياضة",
    mainEn: "Sports",
    items: [{ subAr: "الأجهزة الرياضية", subEn: "Sports Equipment", percentage: "11%" }],
  },
  {
    mainAr: "أدوات مكتبية",
    mainEn: "Office Supplies",
    items: [{ subAr: "جميع", subEn: "All", percentage: "12%" }],
  },
  {
    mainAr: "الأثاث",
    mainEn: "Furniture",
    items: [
      { subAr: "الأثاث الداخلي", subEn: "Indoor Furniture", percentage: "35%" },
      { subAr: "الأثاث المعدني", subEn: "Metal Furniture", percentage: "35%" },
      { subAr: "الأثاث المكتبي", subEn: "Office Furniture", percentage: "35%" },
      { subAr: "أثاث الحدائق", subEn: "Garden Furniture", percentage: "35%" },
      { subAr: "المرايات", subEn: "Mirrors", percentage: "27%" },
      { subAr: "الإضاءة والنجف", subEn: "Lighting & Chandeliers", percentage: "25%" },
      { subAr: "المطابخ", subEn: "Kitchens", percentage: "35%" },
      { subAr: "الديكور", subEn: "Decor", percentage: "25%" },
    ],
  },
];

